import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import weddingBackground from '../assets/weddingarkaplan.png';
import leafImage from '../assets/yaprak2.png';
import leafImage2 from '../assets/yaprak1.png';
import weddingMusic from '../assets/wedding2music.mp3';
import hotelImage from '../assets/a-realistic-and-aesthetic-image-of-a-hotel-taken-f.png';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

// Rastgele bir gelecek tarih oluşturan fonksiyon
const getRandomFutureDate = () => {
    const today = new Date();
    const future = new Date();
    // 30 ile 365 gün arasında rastgele bir gün ekle
    const randomDays = Math.floor(Math.random() * 336) + 30; // 30-365 gün arası
    future.setDate(today.getDate() + randomDays);
    future.setHours(15); // Saati sabit tutalım (örneğin 15:00)
    future.setMinutes(0);
    future.setSeconds(0);
    future.setMilliseconds(0);
    return future;
};

const Wedding = () => {
    const navigate = useNavigate();

    // Düğün tarihi state'i - rastgele oluşturulan tarih
    const [weddingDate] = useState(getRandomFutureDate());

    // Geri sayım için state
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    // Müzik kontrolü için state
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    // Müzik çalma/durdurma fonksiyonu
    const toggleMusic = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    // Scroll fonksiyonu - detaylı bilgiler için
    const scrollToDetails = () => {
        const infoSection = document.getElementById('wedding-info');
        if (infoSection) {
            infoSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        // Sayfa yüklendiğinde en üste scroll et
        window.scrollTo(0, 0);

        // Fontları yükle
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;600;700&family=Inter:wght@300;400;500&family=Nunito:wght@300;400;500&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    // Geri sayım timer'ı
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = weddingDate.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [weddingDate]);

    // Floating particles için rastgele konumlar ve renkler oluştur
    const generateParticles = () => {
        const particles = [];
        const colors = ['#575956', '#efa38b', '#8b9a7a', '#d4a98a', '#6b7569'];

        for (let i = 0; i < 20; i++) {
            particles.push({
                id: i,
                left: Math.random() * 95 + 2.5, // %2.5 - %97.5 arası
                delay: Math.random() * 8, // 0-8 saniye gecikme
                duration: 12 + Math.random() * 8, // 12-20 saniye süre
                size: 2 + Math.random() * 5, // 2-7px boyut
                color: colors[Math.floor(Math.random() * colors.length)],
                opacity: 0.4 + Math.random() * 0.5, // 0.4-0.9 opaklık
                sidewaysDelay: Math.random() * 3 // yan hareket için gecikme
            });
        }
        return particles;
    };

    // Çift görselindeki erkek ve kadın arkasından çıkan kalpler
    const generateCoupleHearts = () => {
        const coupleHearts = [];
        const heartColors = ['#ff69b4', '#ff1493', '#ff6b9d', '#ffc0cb', '#ffb6c1', '#e91e63', '#ff4081', '#f8bbd9'];

        // Erkek arkasından çıkan kalpler (sol taraf)
        for (let i = 0; i < 8; i++) {
            coupleHearts.push({
                id: `male-${i}`,
                left: 25 + Math.random() * 15, // Erkek figürü arkasında %25-40 arası
                delay: Math.random() * 8, // 0-8 saniye gecikme
                duration: 10 + Math.random() * 6, // 10-16 saniye süre
                size: 6 + Math.random() * 8, // 6-14px boyut
                color: heartColors[Math.floor(Math.random() * heartColors.length)],
                opacity: 0.5 + Math.random() * 0.5, // 0.5-1.0 opaklık
                sidewaysOffset: (Math.random() - 0.5) * 40, // -20px ile +20px arası yan hareket
                type: 'male'
            });
        }

        // Kadın arkasından çıkan kalpler (sağ taraf)
        for (let i = 0; i < 8; i++) {
            coupleHearts.push({
                id: `female-${i}`,
                left: 60 + Math.random() * 15, // Kadın figürü arkasında %60-75 arası
                delay: Math.random() * 8, // 0-8 saniye gecikme
                duration: 10 + Math.random() * 6, // 10-16 saniye süre
                size: 6 + Math.random() * 8, // 6-14px boyut
                color: heartColors[Math.floor(Math.random() * heartColors.length)],
                opacity: 0.5 + Math.random() * 0.5, // 0.5-1.0 opaklık
                sidewaysOffset: (Math.random() - 0.5) * 40, // -20px ile +20px arası yan hareket
                type: 'female'
            });
        }

        return coupleHearts;
    };

    const particles = generateParticles();
    const coupleHearts = generateCoupleHearts();

    const generatePDF = () => {
        const letterTextElement = document.getElementById('letterText');
        const signatureElement = document.getElementById('letterSignature');

        if (!letterTextElement || !signatureElement || !letterTextElement.value || !signatureElement.value) {
            alert('Lütfen dileklerinizi yazın ve imzalayın.');
            return;
        }

        const letterContainer = document.querySelector('.luxury-letter-container');
        if (!letterContainer) {
            console.error('Mektup konteyneri bulunamadı.');
            return;
        }

        // Mobil cihaz kontrolü
        const isMobile = window.innerWidth <= 768;

        // Mobil için özel ayarlar - Yatay format için optimize edilmiş
        const canvasOptions = {
            scale: isMobile ? 2 : 3,
            useCORS: true,
            backgroundColor: null,
            logging: false,
            width: isMobile ? 1000 : undefined,
            height: isMobile ? 700 : undefined,
            onclone: (clonedDoc) => {
                const container = clonedDoc.querySelector('.luxury-letter-container');

                // Mobil için container boyutlarını ayarla - Yatay format
                if (isMobile && container) {
                    container.style.width = '1000px';
                    container.style.height = '700px';
                    container.style.padding = '40px';
                    container.style.fontSize = '16px';
                    container.style.transform = 'none';
                    container.style.position = 'relative';
                    container.style.display = 'flex';
                    container.style.flexDirection = 'column';
                    container.style.justifyContent = 'center';
                    container.style.alignItems = 'center';
                    container.style.textAlign = 'center';
                    container.style.margin = '0 auto';
                }

                // 1. İndir butonunu gizle
                const button = container.querySelector('.luxury-letter-download-btn');
                if (button) button.style.display = 'none';

                // 2. Footer'ı düzenleyerek imzayı merkeze yasla (mobil için)
                const footer = container.querySelector('.luxury-letter-footer');
                if (footer) {
                    if (isMobile) {
                        footer.style.justifyContent = 'center';
                        footer.style.textAlign = 'center';
                        footer.style.paddingRight = '0';
                        footer.style.width = '100%';
                    } else {
                        footer.style.justifyContent = 'flex-end';
                        footer.style.paddingRight = '30px';
                    }
                }

                // 3. İmza input'unu metin içeren bir div'e dönüştür
                const signatureInput = container.querySelector('.luxury-letter-signature-input');
                if (signatureInput) {
                    const signatureDiv = clonedDoc.createElement('div');
                    signatureDiv.className = signatureInput.className;
                    signatureDiv.textContent = signatureInput.value;
                    if (isMobile) {
                        signatureDiv.style.fontSize = '16px';
                        signatureDiv.style.textAlign = 'center';
                        signatureDiv.style.width = '100%';
                    }
                    signatureInput.parentNode.replaceChild(signatureDiv, signatureInput);
                }

                // 4. Textarea'yı metni saran bir div'e dönüştür
                const textarea = container.querySelector('.luxury-letter-textarea');
                if (textarea) {
                    const textDiv = clonedDoc.createElement('div');
                    textDiv.className = textarea.className;
                    Object.assign(textDiv.style, {
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        height: 'auto',
                        fontSize: isMobile ? '16px' : undefined,
                        lineHeight: isMobile ? '1.6' : undefined,
                        textAlign: isMobile ? 'center' : undefined,
                        width: isMobile ? '100%' : undefined,
                        maxWidth: isMobile ? '800px' : undefined,
                        margin: isMobile ? '0 auto' : undefined,
                    });
                    textDiv.textContent = textarea.value;
                    textarea.parentNode.replaceChild(textDiv, textarea);
                }

                // 5. Mobil için başlık ve diğer elementleri merkeze hizala
                if (isMobile) {
                    const header = container.querySelector('.luxury-letter-header');
                    if (header) {
                        header.style.textAlign = 'center';
                        header.style.width = '100%';
                    }

                    const body = container.querySelector('.luxury-letter-body');
                    if (body) {
                        body.style.textAlign = 'center';
                        body.style.width = '100%';
                        body.style.display = 'flex';
                        body.style.flexDirection = 'column';
                        body.style.alignItems = 'center';
                    }
                }
            }
        };

        html2canvas(letterContainer, canvasOptions).then(canvas => {
            const imgData = canvas.toDataURL('image/png', 1.0);

            // A4 boyutları (mm)
            const a4Width = 210;
            const a4Height = 297;

            // Mobil için yatay mod zorla
            let pdfWidth, pdfHeight, orientation;

            if (isMobile) {
                // Mobil için yatay mod
                pdfWidth = a4Height; // 297mm
                pdfHeight = a4Width; // 210mm
                orientation = 'landscape';
            } else {
                // Masaüstü için dinamik boyutlandırma
                pdfWidth = a4Height;
                pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                orientation = 'landscape';
            }

            const doc = new jsPDF({
                orientation: orientation,
                unit: 'mm',
                format: isMobile ? [pdfWidth, pdfHeight] : [pdfWidth, pdfHeight]
            });

            // Görüntüyü PDF'e ekle - Mobil için merkeze yerleştir
            const imgWidth = pdfWidth;
            const imgHeight = isMobile ? pdfHeight : (canvas.height * pdfWidth) / canvas.width;

            // Mobil için görüntüyü merkeze yerleştir
            let xPosition = 0;
            let yPosition = 0;

            if (isMobile) {
                // Yatay formatta merkeze yerleştir
                const actualImgWidth = (canvas.width * pdfHeight) / canvas.height;
                const actualImgHeight = pdfHeight;
                
                if (actualImgWidth <= pdfWidth) {
                    xPosition = (pdfWidth - actualImgWidth) / 2;
                    yPosition = 0;
                    doc.addImage(imgData, 'PNG', xPosition, yPosition, actualImgWidth, actualImgHeight, undefined, 'FAST');
                } else {
                    xPosition = 0;
                    yPosition = 0;
                    doc.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight, undefined, 'FAST');
                }
            } else {
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'FAST');
            }
            doc.save('mehmet-ve-ayse-icin-dileklerim.pdf');
        }).catch(err => {
            console.error("PDF oluşturulurken hata oluştu:", err);
            alert('PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
        });
    };

    return (
        <div className="w-full relative overflow-hidden">
            {/* Geri Dönme Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-6 left-6 z-50 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-200/50"
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>

            {/* Arka Plan Görseli */}
            <div
                className="fixed inset-0 z-0 wedding-background"
                style={{
                    backgroundImage: `url(${weddingBackground})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed',
                }}
            >
                {/* Arka plan overlay (isteğe bağlı) */}
                <div className="absolute inset-0 bg-black/10"></div>
            </div>

            {/* Ana Ekran (İlk Görünüm) */}
            <div className="relative w-full min-h-screen">
                {/* Floating Particles */}
                <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden">
                    {particles.map((particle) => (
                        <div
                            key={particle.id}
                            className="floating-particle"
                            style={{
                                left: `${particle.left}%`,
                                width: `${particle.size}px`,
                                height: `${particle.size}px`,
                                backgroundColor: particle.color,
                                opacity: particle.opacity,
                                animationDelay: `${particle.delay}s, ${particle.sidewaysDelay}s`,
                                animationDuration: `${particle.duration}s, 6s`,
                            }}
                        />
                    ))}
                </div>

                {/* Çift Görselindeki Kalpler */}
                <div className="absolute inset-0 z-15 pointer-events-none overflow-hidden">
                    {coupleHearts.map((heart) => (
                        <div
                            key={heart.id}
                            className={`couple-heart-particle ${heart.type === 'male' ? 'male-heart' : 'female-heart'}`}
                            style={{
                                left: `${heart.left}%`,
                                bottom: '20%', // Çiftin bulunduğu yükseklik
                                width: `${heart.size}px`,
                                height: `${heart.size}px`,
                                color: heart.color,
                                opacity: heart.opacity,
                                animationDelay: `${heart.delay}s`,
                                animationDuration: `${heart.duration}s`,
                                '--sideways-offset': `${heart.sidewaysOffset}px`
                            }}
                        />
                    ))}
                </div>

                {/* Çiftin İsimleri */}
                <div className="absolute bottom-64 md:bottom-52 lg:bottom-56 left-1/2 transform -translate-x-1/2 z-30">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight names-container">
                            <span className="first-name slide-from-left" style={{ color: '#575956' }}>Mehmet</span>
                            <span className="ampersand brush-animation mx-2 md:mx-3 lg:mx-4" style={{ color: '#efa38b' }}>&</span>
                            <span className="second-name slide-from-right" style={{ color: '#575956' }}>Ayşe</span>
                        </h1>
                        <p className="invitation-text mt-4 md:mt-6 lg:mt-8 px-6 md:px-8 lg:px-10 text-lg md:text-xl lg:text-2xl">
                            En mutlu günümüzde<br />
                            sizleri de aramızda görmekten<br />
                            mutluluk duyarız.
                        </p>
                    </div>
                </div>

                {/* Geri Sayım Sayacı */}
                <div className="absolute bottom-32 sm:bottom-28 md:bottom-12 lg:bottom-16 left-1/2 transform -translate-x-1/2 z-30 w-full px-4">
                    <div className="countdown-container">
                        <div className="countdown-wrapper">
                            <div className="countdown-item">
                                <div className="countdown-number" style={{ color: '#575956' }}>
                                    {timeLeft.days.toString().padStart(2, '0')}
                                </div>
                                <div className="countdown-label" style={{ color: '#efa38b' }}>
                                    Gün
                                </div>
                            </div>

                            <div className="countdown-separator" style={{ color: '#8b9a7a' }}>:</div>

                            <div className="countdown-item">
                                <div className="countdown-number" style={{ color: '#575956' }}>
                                    {timeLeft.hours.toString().padStart(2, '0')}
                                </div>
                                <div className="countdown-label" style={{ color: '#efa38b' }}>
                                    Saat
                                </div>
                            </div>

                            <div className="countdown-separator" style={{ color: '#8b9a7a' }}>:</div>

                            <div className="countdown-item">
                                <div className="countdown-number" style={{ color: '#575956' }}>
                                    {timeLeft.minutes.toString().padStart(2, '0')}
                                </div>
                                <div className="countdown-label" style={{ color: '#efa38b' }}>
                                    Dakika
                                </div>
                            </div>

                            <div className="countdown-separator" style={{ color: '#8b9a7a' }}>:</div>

                            <div className="countdown-item">
                                <div className="countdown-number" style={{ color: '#575956' }}>
                                    {timeLeft.seconds.toString().padStart(2, '0')}
                                </div>
                                <div className="countdown-label" style={{ color: '#efa38b' }}>
                                    Saniye
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Müzik ve Detaylı Bilgiler Butonları */}
                <div className="absolute bottom-4 sm:bottom-6 md:bottom-4 lg:bottom-6 left-1/2 transform -translate-x-1/2 z-30 w-full px-4">
                    <div className="button-container">
                        {/* Müzik Butonu */}
                        <button
                            onClick={toggleMusic}
                            className={`action-button music-button ${isPlaying ? 'playing' : ''}`}
                            aria-label={isPlaying ? 'Müziği Durdur' : 'Müziği Çal'}
                        >
                            <div className="button-icon">
                                {isPlaying ? (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                                    </svg>
                                ) : (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M8 5v14l11-7z" />
                                    </svg>
                                )}
                            </div>
                        </button>

                        {/* Aşağı Scroll Butonu */}
                        <button
                            onClick={scrollToDetails}
                            className="action-button details-button"
                            aria-label="Aşağı Scroll"
                        >
                            <div className="button-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6z" />
                                </svg>
                            </div>
                        </button>
                    </div>
                </div>

                {/* Audio Element */}
                <audio
                    ref={audioRef}
                    src={weddingMusic}
                    loop
                    preload="auto"
                    onEnded={() => setIsPlaying(false)}
                />

                {/* Animasyonlu Yaprak Görseli - Çok Yukarıda */}
                <div className="absolute -top-16 left-0 md:-top-20 md:left-0 lg:-top-24 lg:left-0 xl:-top-28 xl:left-0 z-20">
                    <img
                        src={leafImage}
                        alt="Yaprak"
                        className="leaf-animation w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 xl:w-[28rem] xl:h-[28rem] 2xl:w-[32rem] 2xl:h-[32rem] opacity-90 drop-shadow-2xl"
                    />
                </div>

                {/* İkinci Yaprak Görseli - Sağ Alt Köşe */}
                <div className="absolute -bottom-20 -right-8 md:-bottom-20 md:right-0 lg:-bottom-24 lg:right-0 xl:-bottom-28 xl:right-0 z-20">
                    <img
                        src={leafImage2}
                        alt="Yaprak2"
                        className="leaf-animation-2 w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 xl:w-[28rem] xl:h-[28rem] 2xl:w-[32rem] 2xl:h-[32rem] opacity-90 drop-shadow-2xl"
                    />
                </div>
            </div>

            {/* Düğün Bilgileri Bölümü */}
            <div id="wedding-info" className="relative w-full min-h-screen bg-gradient-to-b from-white/95 to-white/90 backdrop-blur-sm z-40 wedding-info-section">
                <div className="max-w-6xl mx-auto px-4 py-16 md:py-20">
                    {/* Başlık */}
                    <div className="text-center mb-16">
                        <h2 className="wedding-info-title text-4xl md:text-5xl lg:text-6xl mb-6" style={{ color: '#575956' }}>
                            Düğün Bilgileri
                        </h2>
                        <div className="wedding-info-line mx-auto"></div>
                    </div>

                    {/* Ana İçerik - Grid */}
                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
                        {/* Sol Taraf - Bilgiler */}
                        <div className="space-y-8">
                            {/* Tarih ve Saat */}
                            <div className="wedding-info-card">
                                <div className="wedding-info-icon" style={{ color: '#efa38b' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                                    </svg>
                                </div>
                                <div className="wedding-info-content">
                                    <h3 className="wedding-info-card-title" style={{ color: '#575956' }}>Tarih & Saat</h3>
                                    <p className="wedding-info-card-text" style={{ color: '#6b7569' }}>
                                        <span className="block text-lg font-semibold" style={{ color: '#575956' }}>
                                            {weddingDate.toLocaleDateString('tr-TR', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            })}
                                        </span>
                                        <span className="block">
                                            {weddingDate.toLocaleDateString('tr-TR', { weekday: 'long' })} - 15:00
                                        </span>
                                        <span className="block text-sm mt-1 opacity-80">Nikah Töreni: 15:00 | Düğün: 19:00</span>
                                    </p>
                                </div>
                            </div>

                            {/* Mekan Bilgileri */}
                            <div className="wedding-info-card">
                                <div className="wedding-info-icon" style={{ color: '#8b9a7a' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                    </svg>
                                </div>
                                <div className="wedding-info-content">
                                    <h3 className="wedding-info-card-title" style={{ color: '#575956' }}>Mekan</h3>
                                    <p className="wedding-info-card-text" style={{ color: '#6b7569' }}>
                                        <span className="block text-lg font-semibold" style={{ color: '#575956' }}>Bosphorus Palace</span>
                                        <span className="block">Uskudar, İstanbul</span>
                                        <span className="block text-sm mt-1 opacity-80">Kuzguncuk Mahallesi, Sahil Yolu No:42</span>
                                    </p>
                                </div>
                            </div>

                            {/* Kıyafet Kodu yerine Ek Bilgiler Kartı */}
                            <div className="wedding-info-card">
                                <div className="wedding-info-icon" style={{ color: '#d4a98a' }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                                    </svg>
                                </div>
                                <div className="wedding-info-content">
                                    <h3 className="wedding-info-card-title" style={{ color: '#575956' }}>Ek Bilgiler</h3>
                                    <p className="wedding-info-card-text" style={{ color: '#6b7569' }}>
                                        <span className="block text-lg font-semibold" style={{ color: '#575956' }}>Önemli Notlar</span>
                                        <span className="block text-sm mt-1 opacity-80">Törenimiz açık havada olacağı için hava durumuna uygun giyinmenizi rica ederiz. Minik misafirlerimiz için oyun alanı mevcuttur.</span>
                                    </p>
                                </div>
                            </div>

                            {/* Yol Tarifi Butonu */}
                            <div className="mt-8">
                                <button
                                    onClick={() => window.open('https://maps.google.com/?q=Kuzguncuk+Mahallesi+Sahil+Yolu+No:42+Uskudar+Istanbul', '_blank')}
                                    className="wedding-directions-btn w-full"
                                >
                                    <div className="flex items-center justify-center gap-3">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.39.39-1.02 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z" />
                                        </svg>
                                        <span className="text-lg font-semibold">Yol Tarifi Al</span>
                                    </div>
                                </button>
                            </div>
                        </div>

                        {/* Sağ Taraf - Hotel Görseli */}
                        <div className="wedding-map-container">
                            <div className="wedding-map-header">
                                <h3 className="wedding-info-card-title" style={{ color: '#575956' }}>Konum</h3>
                                <p className="text-sm opacity-80" style={{ color: '#6b7569' }}>Düğün mekanımızın konumu</p>
                            </div>

                            {/* Hotel Görseli */}
                            <div className="wedding-map-frame">
                                <img
                                    src={hotelImage}
                                    alt="The Palm Bosphorus Hotel"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '15px'
                                    }}
                                />
                            </div>

                            {/* Harita Alt Bilgi */}
                            <div className="wedding-map-footer">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="font-semibold" style={{ color: '#575956' }}>The Palm Bosphorus Hotel</p>
                                        <p className="text-sm opacity-80" style={{ color: '#6b7569' }}>Mimar Sinan Mah. Doğancılar Cad. No:40/A Üsküdar/İstanbul</p>
                                    </div>
                                    <button
                                        onClick={() => window.open('https://maps.app.goo.gl/J2UpLJ5H5seWk7478', '_blank')}
                                        className="wedding-map-btn"
                                        style={{ color: '#efa38b' }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Alt Bilgi */}
                    <div className="text-center mt-16 pt-8 border-t border-gray-200/50">
                        <p className="text-lg" style={{ color: '#6b7569' }}>
                            Herhangi bir sorunuz varsa bizimle iletişime geçebilirsiniz.
                        </p>
                        <div className="flex justify-center gap-6 mt-4">
                            <a href="tel:+905551234567" className="wedding-contact-link">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                </svg>
                                İletişime Geç
                            </a>

                        </div>

                        {/* Mektup bölümüne kaydırma butonu */}
                        <div className="mt-12">
                            <button
                                onClick={() => document.getElementById('wishes-section').scrollIntoView({ behavior: 'smooth' })}
                                className="scroll-to-wishes-btn"
                            >
                                <span>Güzel Dileklerinizi Yazın</span>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Güzel Dilekleriniz İçin Mektup Bölümü */}
            <div id="wishes-section" className="relative w-full py-20 bg-gradient-to-b from-white/90 to-white/95 backdrop-blur-sm z-40">
                <div className="max-w-6xl mx-auto px-4">
                    {/* Başlık */}
                    <div className="text-center mb-16">
                        <h2 className="wedding-info-title text-4xl md:text-5xl lg:text-6xl mb-6" style={{ color: '#575956' }}>
                            Güzel Dilekleriniz İçin Mektup
                        </h2>
                        <div className="wedding-info-line mx-auto"></div>
                        <p className="mt-6 text-lg md:text-xl max-w-2xl mx-auto" style={{ color: '#6b7569', fontFamily: 'Nunito, sans-serif' }}>
                            Mutluluğumuzu paylaşmak için yazacağınız güzel dilekleriniz bizim için çok değerli.
                        </p>

                        {/* Hazır Dilek Şablonları */}
                        <div className="mt-6 max-w-4xl mx-auto">
                            <h4 className="text-center text-xl mb-4" style={{ color: '#575956', fontFamily: 'Nunito, sans-serif' }}>
                                Hazır Dilek Şablonları
                            </h4>
                            <div className="grid md:grid-cols-3 gap-4">
                                <div
                                    className="wish-template-card"
                                    onClick={() => {
                                        document.getElementById('letterText').value = "Sevgili Mehmet ve Ayşe, hayatınızın bu en özel gününde size sonsuz mutluluklar diliyorum. Birlikte attığınız bu adımın, ömür boyu sürecek bir mutluluğun, sevginizin ve saygınızın başlangıcı olmasını temenni ederim. Yolunuz her daim aydınlık, gönlünüz hep sevgi dolu olsun. Birbirinize olan sevginiz hiç eksilmesin, her geçen gün daha da artsın.";
                                    }}
                                >
                                    <div className="wish-template-content">
                                        <p className="wish-template-preview">
                                            "Sevgili Mehmet ve Ayşe, hayatınızın bu en özel gününde size sonsuz mutluluklar diliyorum. Birlikte attığınız bu adımın, ömür boyu sürecek bir mutluluğun..."
                                        </p>
                                        <div className="wish-template-button">
                                            <span>Bu Dileği Seç</span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="wish-template-card"
                                    onClick={() => {
                                        document.getElementById('letterText').value = "Değerli çift, evlilik yolculuğunuzun başlangıcında sizlere en içten dileklerimi sunuyorum. Hayatınız boyunca birbirinize olan sevginiz ilk günkü gibi taze kalsın, zorlukları birlikte aşacak gücü her zaman bulun. Mutluluğunuzu paylaşacağınız nice yıllar, birlikte yaşayacağınız güzel anılar ve sevgi dolu bir yuva diliyorum.";
                                    }}
                                >
                                    <div className="wish-template-content">
                                        <p className="wish-template-preview">
                                            "Değerli çift, evlilik yolculuğunuzun başlangıcında sizlere en içten dileklerimi sunuyorum. Hayatınız boyunca birbirinize olan sevginiz ilk günkü gibi taze kalsın..."
                                        </p>
                                        <div className="wish-template-button">
                                            <span>Bu Dileği Seç</span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="wish-template-card"
                                    onClick={() => {
                                        document.getElementById('letterText').value = "Hayat boyu el ele, gönül gönüle nice güzel günler geçirmenizi diliyorum. Aşkınız her geçen gün daha da büyüsün, birlikte gülümsediğiniz anlar hiç bitmesin. Birbirinize destek olduğunuz, sevgi ve saygıyla dolu bir evlilik hayatı sizin olsun. Bu mutlu gününüzde yanınızda olmaktan büyük mutluluk duyuyorum.";
                                    }}
                                >
                                    <div className="wish-template-content">
                                        <p className="wish-template-preview">
                                            "Hayat boyu el ele, gönül gönüle nice güzel günler geçirmenizi diliyorum. Aşkınız her geçen gün daha da büyüsün, birlikte gülümsediğiniz anlar hiç bitmesin..."
                                        </p>
                                        <div className="wish-template-button">
                                            <span>Bu Dileği Seç</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Lüks Mektup Tasarımı */}
                    <div className="max-w-4xl mx-auto">
                        <div className="luxury-letter-container">
                            {/* Dekoratif Süslemeler */}
                            <div className="luxury-letter-decorations">
                                <div className="luxury-letter-corner top-left"></div>
                                <div className="luxury-letter-corner top-right"></div>
                                <div className="luxury-letter-corner bottom-left"></div>
                                <div className="luxury-letter-corner bottom-right"></div>
                                <div className="luxury-letter-edge top"></div>
                                <div className="luxury-letter-edge right"></div>
                                <div className="luxury-letter-edge bottom"></div>
                                <div className="luxury-letter-edge left"></div>
                            </div>

                            {/* Mektup İçeriği */}
                            <div id="letterContent" className="luxury-letter-content">
                                {/* Üst Kısım Süslemesi */}
                                <div className="luxury-letter-header">
                                    <div className="luxury-letter-ornament left">
                                        <img src={leafImage2} alt="Süsleme Çiçek Sol" className="flower-ornament" />
                                    </div>
                                    <div className="luxury-letter-title">
                                        <h3>Sevgili Mehmet & Ayşe</h3>
                                        <div className="luxury-letter-title-underline"></div>
                                    </div>
                                    <div className="luxury-letter-ornament right">
                                        <img src={leafImage} alt="Süsleme Çiçek Sağ" className="flower-ornament" />
                                    </div>
                                </div>

                                {/* Metin Alanı */}
                                <div className="luxury-letter-body">
                                    <textarea
                                        id="letterText"
                                        className="luxury-letter-textarea"
                                        placeholder="Sevgili Mehmet ve Ayşe, bu özel gününüzde size en içten dileklerimi sunmak istiyorum..."
                                        rows="6"
                                    ></textarea>
                                </div>

                                {/* İmza ve Gönder */}
                                <div className="luxury-letter-footer">
                                    <div className="luxury-letter-signature">
                                        <input
                                            id="letterSignature"
                                            type="text"
                                            className="luxury-letter-signature-input"
                                            placeholder="İsminiz"
                                        />
                                        <div className="luxury-letter-signature-line"></div>
                                    </div>
                                    <button
                                        onClick={() => generatePDF()}
                                        className="luxury-letter-download-btn"
                                    >
                                        <span>İndir</span>
                                        <div className="luxury-letter-download-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                                            </svg>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Altın Süslemeli Ayraç */}
                    <div className="luxury-divider">
                        <div className="luxury-divider-line left"></div>
                        <div className="luxury-divider-ornament">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                            </svg>
                        </div>
                        <div className="luxury-divider-line right"></div>
                    </div>

                    {/* Dilek Kartları Örneği */}
                    <div className="mt-16">

                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">






                        </div>
                    </div>
                </div>
            </div>

            {/* Düğün Sayfası Footer Alanı - Görseldeki gibi minimalist tasarım */}
            <div className="wedding-footer-new">
                <div className="wedding-footer-center">
                    {/* Kalp İkonu */}
                    <div className="wedding-footer-heart-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                        </svg>
                    </div>

                    {/* Çift İsmi */}
                    <h2 className="wedding-footer-couple">Mehmet & Ayşe</h2>

                    {/* Teşekkür Mesajı */}
                    <p className="wedding-footer-message">
                        "Sevgimizi paylaştığımız bu özel günde bizimle olduğunuz için
                        teşekkür ederiz. Hayatımızın en güzel anında yanımızda olmanız
                        bizim için çok değerli."
                    </p>

                    {/* İki Sütunlu Alt Kısım */}
                    <div className="wedding-footer-columns">
                        {/* Sol Sütun - İletişim */}
                        <div className="wedding-footer-column">
                            <h3 className="wedding-footer-subtitle">İletişim</h3>
                            <div className="wedding-footer-contact-item">
                                <div className="wedding-footer-icon-circle">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                    </svg>
                                </div>
                                <span>+90 555 123 45 67</span>
                            </div>
                            <div className="wedding-footer-contact-item">
                                <div className="wedding-footer-icon-circle">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                    </svg>
                                </div>
                                <span>mehmet.ayse@wedding.com</span>
                            </div>
                        </div>

                        {/* Sağ Sütun - Aşkımızı Tanığı Olun */}
                        <div className="wedding-footer-column">
                            <h3 className="wedding-footer-subtitle">Aşkımızın Tanığı Olun</h3>
                            <p className="wedding-footer-witness">
                                Bu güzel yolculukta bizimle birlikte olmanız, hayatımızdaki en
                                mutlu anları daha da özel kılıyor.
                            </p>
                        </div>
                    </div>

                    {/* Alt Çizgi */}
                    <div className="wedding-footer-divider-new"></div>

                    {/* En Alt Kısım - Copyright */}
                    <div className="wedding-footer-bottom-new">
                        <p className="wedding-footer-copyright-new">
                            ©2025 Mehmet & Ayşe Düğün Davetiyesi
                        </p>
                        <p className="wedding-footer-quote">
                            "Aşka inanmak bir yaşam biçimidir"
                        </p>
                        <p className="wedding-footer-credit-new">
                            Projeyi geliştiren <span>DijiVite</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* CSS Styles */}
            <style jsx global>{`
            /* Footer'ı bu sayfada gizle */
            footer {
                display: none !important;
            }

            /* Header'ı da gizlemek isterseniz (isteğe bağlı) */
            /* header {
                display: none !important;
            } */

            /* Body'nin margin/padding'ini sıfırla */
            body {
                margin: 0 !important;
                padding: 0 !important;
            }

            /* Floating Particles Animasyonu */
            @keyframes floatUpContinuous {
                0% {
                    transform: translateY(120vh) translateX(0px) rotate(0deg);
                    opacity: 0;
                }
                5% {
                    opacity: 0.6;
                }
                95% {
                    opacity: 0.6;
                }
                100% {
                    transform: translateY(-120px) translateX(30px) rotate(360deg);
                    opacity: 0;
                }
            }

            @keyframes floatSideways {
                0%, 100% {
                    transform: translateX(0px);
                }
                33% {
                    transform: translateX(-15px);
                }
                66% {
                    transform: translateX(15px);
                }
            }

            .floating-particle {
                position: absolute;
                bottom: -100px;
                animation: floatUpContinuous linear infinite, floatSideways ease-in-out infinite;
                will-change: transform, opacity;
                border-radius: 50%;
                box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
            }

            /* Farklı boyutlardaki partiküller için farklı glow efektleri */
            .floating-particle:nth-child(odd) {
                box-shadow: 0 0 10px rgba(239, 163, 139, 0.5);
            }

            .floating-particle:nth-child(even) {
                box-shadow: 0 0 8px rgba(87, 89, 86, 0.4);
            }

            .floating-particle:nth-child(3n) {
                box-shadow: 0 0 6px rgba(139, 154, 122, 0.4);
            }

            .floating-particle:nth-child(4n) {
                box-shadow: 0 0 12px rgba(212, 169, 138, 0.3);
            }

            /* GERI SAYIM SAYACI STİLLERİ */
            .countdown-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                max-width: 600px;
                margin: 0 auto;
                background: rgba(255, 255, 255, 0.15);
                backdrop-filter: blur(15px);
                border-radius: 25px;
                padding: 20px 15px;
                border: 2px solid rgba(239, 163, 139, 0.3);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.1),
                    inset 0 1px 0 rgba(255, 255, 255, 0.4),
                    0 0 40px rgba(239, 163, 139, 0.1);
                animation: countdownAppear 1.5s ease-out 2s forwards;
                opacity: 0;
                transform: translateY(30px);
            }

            .countdown-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                width: 100%;
                flex-wrap: nowrap;
            }

            .countdown-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-width: 70px;
                position: relative;
                animation: countdownPulse 2s ease-in-out infinite;
            }

            .countdown-number {
                font-family: 'Dancing Script', cursive;
                font-weight: 700;
                font-size: 2.8rem;
                line-height: 1;
                text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
                animation: numberFlip 1s ease-in-out;
                position: relative;
            }

            .countdown-label {
                font-family: 'Nunito', sans-serif;
                font-weight: 500;
                font-size: 0.9rem;
                margin-top: 4px;
                text-transform: uppercase;
                letter-spacing: 1px;
                text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
            }

            .countdown-separator {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-size: 2.5rem;
                line-height: 1;
                margin: 0 5px;
                animation: separatorBlink 2s ease-in-out infinite;
                text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
            }

            /* Animasyonlar */
            @keyframes countdownAppear {
                0% {
                    opacity: 0;
                    transform: translateY(30px) scale(0.9);
                }
                60% {
                    opacity: 0.8;
                    transform: translateY(-5px) scale(1.02);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                }
            }

            @keyframes countdownPulse {
                0%, 100% {
                    transform: scale(1);
                }
                50% {
                    transform: scale(1.02);
                }
            }

            @keyframes numberFlip {
                0% {
                    transform: rotateY(0deg);
                }
                50% {
                    transform: rotateY(90deg);
                }
                100% {
                    transform: rotateY(0deg);
                }
            }

            @keyframes separatorBlink {
                0%, 100% {
                    opacity: 1;
                    transform: scale(1);
                }
                50% {
                    opacity: 0.6;
                    transform: scale(1.1);
                }
            }

            /* Hover efektleri */
            .countdown-container:hover {
                transform: translateY(-2px);
                box-shadow: 
                    0 12px 40px rgba(0, 0, 0, 0.15),
                    inset 0 1px 0 rgba(255, 255, 255, 0.5),
                    0 0 60px rgba(239, 163, 139, 0.2);
                transition: all 0.3s ease;
            }

            .countdown-item:hover .countdown-number {
                transform: scale(1.1);
                transition: transform 0.3s ease;
            }

            .countdown-item:hover .countdown-label {
                transform: translateY(-2px);
                transition: transform 0.3s ease;
            }

            /* Responsive tasarım */
            @media (max-width: 768px) {
                .countdown-container {
                    max-width: 90%;
                    padding: 15px 10px;
                    border-radius: 20px;
                }
                
                .countdown-wrapper {
                    gap: 4px;
                }
                
                .countdown-item {
                    min-width: 60px;
                }
                
                .countdown-number {
                    font-size: 2.2rem;
                }
                
                .countdown-label {
                    font-size: 0.75rem;
                }
                
                .countdown-separator {
                    font-size: 2rem;
                    margin: 0 3px;
                }
            }

            @media (max-width: 480px) {
                .countdown-container {
                    max-width: 95%;
                    padding: 12px 8px;
                    border-radius: 15px;
                }
                
                .countdown-wrapper {
                    gap: 2px;
                }
                
                .countdown-item {
                    min-width: 50px;
                }
                
                .countdown-number {
                    font-size: 1.8rem;
                }
                
                .countdown-label {
                    font-size: 0.65rem;
                    margin-top: 2px;
                }
                
                .countdown-separator {
                    font-size: 1.6rem;
                    margin: 0 2px;
                }
            }

            @media (max-width: 360px) {
                .countdown-container {
                    padding: 10px 6px;
                }
                
                .countdown-item {
                    min-width: 45px;
                }
                
                .countdown-number {
                    font-size: 1.6rem;
                }
                
                .countdown-label {
                    font-size: 0.6rem;
                }
                
                .countdown-separator {
                    font-size: 1.4rem;
                    margin: 0 1px;
                }
            }

            /* MÜZİK VE DETAYLI BİLGİLER BUTONLARI */
            .button-container {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 16px;
                width: 100%;
                max-width: 400px;
                margin: 0 auto;
                animation: buttonsAppear 1.8s ease-out 3s forwards;
                opacity: 0;
                transform: translateY(30px);
            }

            .action-button {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 14px;
                background: rgba(255, 255, 255, 0.20);
                backdrop-filter: blur(20px);
                border: 2px solid rgba(239, 163, 139, 0.4);
                border-radius: 50%;
                color: #575956;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
                width: 56px;
                height: 56px;
                box-shadow: 
                    0 4px 20px rgba(0, 0, 0, 0.1),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
            }

            .action-button::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                transition: left 0.6s ease;
            }

            .action-button:hover::before {
                left: 100%;
            }

            .action-button:hover {
                transform: translateY(-3px);
                box-shadow: 
                    0 8px 30px rgba(0, 0, 0, 0.15),
                    inset 0 1px 0 rgba(255, 255, 255, 0.4),
                    0 0 25px rgba(239, 163, 139, 0.3);
                border-color: rgba(239, 163, 139, 0.6);
            }

            .action-button:active {
                transform: translateY(-1px);
                transition: transform 0.1s ease;
            }

            .button-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                transition: transform 0.3s ease;
            }

            .action-button:hover .button-icon {
                transform: scale(1.1);
            }



            /* Müzik butonu özel stili */
            .music-button .button-icon {
                color: #8b9a7a;
            }

            .music-button:hover {
                background: rgba(139, 154, 122, 0.15);
            }

            .music-button.playing {
                background: rgba(139, 154, 122, 0.25);
                border-color: rgba(139, 154, 122, 0.6);
            }

            /* Detaylı bilgiler butonu özel stili */
            .details-button .button-icon {
                color: #efa38b;
            }

            .details-button:hover {
                background: rgba(239, 163, 139, 0.15);
            }

            /* Buton animasyonları */
            @keyframes buttonsAppear {
                0% {
                    opacity: 0;
                    transform: translateY(30px) scale(0.9);
                }
                60% {
                    opacity: 0.8;
                    transform: translateY(-5px) scale(1.02);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                }
            }

            @keyframes buttonPulse {
                0%, 100% {
                    transform: scale(1);
                }
                50% {
                    transform: scale(1.05);
                }
            }

            /* Müzik çalarken buton animasyonu */
            .music-button.playing .button-icon {
                animation: buttonPulse 1.5s ease-in-out infinite;
            }

            /* Responsive tasarım - Butonlar */
            @media (max-width: 768px) {
                .button-container {
                    max-width: 90%;
                    gap: 16px;
                }
                
                .action-button {
                    width: 52px;
                    height: 52px;
                    padding: 12px;
                }
                
                .button-icon {
                    width: 22px;
                    height: 22px;
                }
            }

            @media (max-width: 480px) {
                .button-container {
                    gap: 20px;
                    max-width: 95%;
                }
                
                .action-button {
                    width: 48px;
                    height: 48px;
                    padding: 10px;
                }
                
                .button-icon {
                    width: 20px;
                    height: 20px;
                }
            }

            @media (max-width: 360px) {
                .action-button {
                    width: 44px;
                    height: 44px;
                    padding: 8px;
                }
                
                .button-icon {
                    width: 18px;
                    height: 18px;
                }
            }

            /* Yaprak Rüzgar Animasyonu - Dev Boyut İçin */
            @keyframes leafWind {
                0% {
                    transform: translateX(0px) translateY(0px) rotate(0deg);
                }
                25% {
                    transform: translateX(-25px) translateY(-18px) rotate(-8deg);
                }
                50% {
                    transform: translateX(20px) translateY(-25px) rotate(6deg);
                }
                75% {
                    transform: translateX(-12px) translateY(-10px) rotate(-3deg);
                }
                100% {
                    transform: translateX(0px) translateY(0px) rotate(0deg);
                }
            }

            @keyframes leafFloat {
                0%, 100% {
                    transform: translateY(0px) rotate(0deg);
                }
                50% {
                    transform: translateY(-30px) rotate(12deg);
                }
            }

            .leaf-animation {
                animation: leafWind 4s ease-in-out infinite, leafFloat 3s ease-in-out infinite;
                animation-delay: 0s, 1s;
                transform-origin: center bottom;
                filter: drop-shadow(2px 4px 8px rgba(0,0,0,0.2));
                transition: opacity 0.3s ease;
            }

            .leaf-animation:hover {
                opacity: 1 !important;
                animation-duration: 2s, 1.5s;
            }

            /* İkinci Yaprak Animasyonu - Sağ Alt */
            .leaf-animation-2 {
                animation: leafWind2 4.5s ease-in-out infinite, leafFloat2 3.5s ease-in-out infinite;
                animation-delay: 1s, 2s;
                transform-origin: center bottom;
                filter: drop-shadow(2px 4px 8px rgba(0,0,0,0.2));
                transition: opacity 0.3s ease;
            }

            .leaf-animation-2:hover {
                opacity: 1 !important;
                animation-duration: 2.5s, 2s;
            }

            /* İkinci yaprak için rüzgar animasyonu */
            @keyframes leafWind2 {
                0% {
                    transform: translateX(0px) translateY(0px) rotate(0deg);
                }
                25% {
                    transform: translateX(25px) translateY(-15px) rotate(8deg);
                }
                50% {
                    transform: translateX(-18px) translateY(-22px) rotate(-5deg);
                }
                75% {
                    transform: translateX(15px) translateY(-8px) rotate(4deg);
                }
                100% {
                    transform: translateX(0px) translateY(0px) rotate(0deg);
                }
            }

            /* İkinci yaprak için yüzdürme animasyonu */
            @keyframes leafFloat2 {
                0%, 100% {
                    transform: translateY(0px) rotate(0deg);
                }
                50% {
                    transform: translateY(-25px) rotate(-10deg);
                }
            }

            /* Mobil uyumluluk için media queries */
            @media (max-width: 768px) {
                .absolute.inset-0 {
                    background-attachment: scroll !important;
                    background-size: cover !important;
                    background-position: center center !important;
                }
                
                /* Mobil cihazlarda partikül sayısını azalt */
                .floating-particle:nth-child(n+11) {
                    display: none;
                }
            }

            @media (max-width: 480px) {
                .absolute.inset-0 {
                    background-size: cover !important;
                    background-position: center top !important;
                }
                
                /* Küçük ekranlarda daha az partikül */
                .floating-particle:nth-child(n+8) {
                    display: none;
                }
            }

            /* Yüksek çözünürlüklü ekranlar için */
            @media (min-width: 1920px) {
                .absolute.inset-0 {
                    background-size: 100% auto !important;
                    background-position: center center !important;
                }
            }

            /* Retina ekranlar için optimizasyon */
            @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
                .absolute.inset-0 {
                    background-size: cover !important;
                }
            }

            /* İsimler Konteyner */
            .names-container {
                position: relative;
                overflow: visible;
                white-space: nowrap;
            }
            
            /* Çift İsimleri Stilı - Görseldeki gibi */
            .first-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromLeft 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(-100px);
            }
            
            .ampersand {
                font-family: 'Dancing Script', cursive;
                font-weight: 500;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                display: inline-block;
                position: relative;
                animation: brushAppear 1s ease-in-out 1.2s forwards;
                opacity: 0;
            }
            
            .second-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromRight 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(100px);
            }
            
            /* İsim Animasyonları */
            @keyframes slideFromLeft {
                0% {
                    transform: translateX(-100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes slideFromRight {
                0% {
                    transform: translateX(100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes brushAppear {
                0% {
                    opacity: 0;
                    transform: scale(0.5) rotate(-10deg);
                    filter: blur(10px);
                }
                30% {
                    opacity: 0.7;
                    transform: scale(1.2) rotate(5deg);
                    filter: blur(3px);
                }
                60% {
                    transform: scale(0.9) rotate(-3deg);
                    filter: blur(0px);
                }
                80% {
                    transform: scale(1.05) rotate(2deg);
                }
                100% {
                    opacity: 1;
                    transform: scale(1) rotate(0deg);
                }
            }
            
            /* Ampersand fırça efekti - Dairesel efekt */
            .ampersand::before, .ampersand::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                background: radial-gradient(circle, rgba(239, 163, 139, 0.2) 0%, rgba(239, 163, 139, 0) 70%);
                border-radius: 50%;
                z-index: -1;
                transform: translate(-50%, -50%) scale(0);
                animation: brushSplash 1.5s ease-out 1.3s forwards;
                pointer-events: none;
            }
            
            .ampersand::after {
                background: radial-gradient(circle, rgba(239, 163, 139, 0.1) 0%, rgba(239, 163, 139, 0) 70%);
                animation-delay: 1.4s;
                animation-duration: 2s;
            }
            
            @keyframes brushSplash {
                0% {
                    transform: translate(-50%, -50%) scale(0);
                    opacity: 0.8;
                }
                100% {
                    transform: translate(-50%, -50%) scale(2.5);
                    opacity: 0;
                }
            }
            
            /* Hover efektleri */
            .first-name:hover, .second-name:hover {
                transform: scale(1.02);
                text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
                transition: all 0.3s ease;
            }
            
            /* Mobil cihazlarda font boyutunu ayarla */
            @media (max-width: 640px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 1px;
                    font-size: 3.5rem !important;
                }
            }
            
            @media (max-width: 480px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 0.5px;
                    font-size: 3rem !important;
                }
            }
            
            /* Davetiye metni stili */
            .invitation-text {
                font-family: 'Nunito', sans-serif;
                color: #575956;
                font-weight: 400;
                line-height: 1.6;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
                opacity: 0.9;
                animation: fadeIn 1s ease-in-out;
            }
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 0.9; transform: translateY(0); }
            }

            /* DÜĞÜN BİLGİLERİ BÖLÜMÜ STİLLERİ */
            .wedding-info-title {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                animation: titleFadeIn 1s ease-out;
            }

            .wedding-info-line {
                width: 100px;
                height: 3px;
                background: linear-gradient(90deg, #efa38b, #8b9a7a);
                border-radius: 2px;
                animation: lineExpand 1.2s ease-out 0.3s forwards;
                transform: scaleX(0);
            }

            .wedding-info-card {
                display: flex;
                align-items: flex-start;
                gap: 20px;
                padding: 24px;
                background: rgba(255, 255, 255, 0.7);
                backdrop-filter: blur(20px);
                border-radius: 20px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                transition: all 0.3s ease;
                animation: cardSlideIn 0.8s ease-out forwards;
                opacity: 0;
                transform: translateY(30px);
            }

            .wedding-info-card:nth-child(1) { animation-delay: 0.2s; }
            .wedding-info-card:nth-child(2) { animation-delay: 0.4s; }
            .wedding-info-card:nth-child(3) { animation-delay: 0.6s; }

            .wedding-info-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 16px 48px rgba(0, 0, 0, 0.12),
                    inset 0 1px 0 rgba(255, 255, 255, 0.8);
                border-color: rgba(239, 163, 139, 0.4);
            }

            .wedding-info-icon {
                flex-shrink: 0;
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 50%;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
            }

            .wedding-info-card:hover .wedding-info-icon {
                transform: scale(1.1);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
            }

            .wedding-info-content {
                flex: 1;
            }

            .wedding-info-card-title {
                font-family: 'Dancing Script', cursive;
                font-size: 1.75rem;
                font-weight: 600;
                margin-bottom: 8px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .wedding-info-card-text {
                font-family: 'Nunito', sans-serif;
                line-height: 1.6;
            }

            /* YOL TARİFİ BUTONU */
            .wedding-directions-btn {
                padding: 18px 32px;
                background: linear-gradient(135deg, #efa38b, #d4a98a);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 8px 24px rgba(239, 163, 139, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
            }

            .wedding-directions-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                transition: left 0.6s ease;
            }

            .wedding-directions-btn:hover::before {
                left: 100%;
            }

            .wedding-directions-btn:hover {
                transform: translateY(-3px);
                box-shadow: 
                    0 12px 36px rgba(239, 163, 139, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                background: linear-gradient(135deg, #f0b49c, #d9b59a);
            }

            .wedding-directions-btn:active {
                transform: translateY(-1px);
            }

            /* HARİTA KONTEYNER */
            .wedding-map-container {
                background: rgba(255, 255, 255, 0.8);
                backdrop-filter: blur(20px);
                border-radius: 25px;
                padding: 24px;
                border: 1px solid rgba(139, 154, 122, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                animation: mapSlideIn 1s ease-out 0.8s forwards;
                opacity: 0;
                transform: translateX(50px);
            }

            .wedding-map-header {
                margin-bottom: 20px;
                text-align: center;
            }

            .wedding-map-frame {
                width: 100%;
                height: 350px;
                border-radius: 15px;
                overflow: hidden;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                margin-bottom: 16px;
            }

            .wedding-map-footer {
                padding: 16px;
                background: rgba(255, 255, 255, 0.6);
                border-radius: 12px;
                border: 1px solid rgba(239, 163, 139, 0.15);
            }

            .wedding-map-btn {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border: 1px solid currentColor;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease;
            }

            .wedding-map-btn:hover {
                background: currentColor;
                color: white !important;
                transform: scale(1.1);
            }

            /* İLETİŞİM LİNKLERİ */
            .wedding-contact-link {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 20px;
                background: rgba(255, 255, 255, 0.6);
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 25px;
                color: #575956;
                text-decoration: none;
                font-family: 'Nunito', sans-serif;
                font-weight: 500;
                transition: all 0.3s ease;
            }

            .wedding-contact-link:hover {
                background: rgba(139, 154, 122, 0.1);
                border-color: rgba(139, 154, 122, 0.5);
                transform: translateY(-2px);
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            }

            /* Mektup bölümüne kaydırma butonu */
            .scroll-to-wishes-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                padding: 14px 28px;
                background: linear-gradient(135deg, #8b9a7a, #6b7569);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 6px 20px rgba(107, 117, 105, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
                margin: 0 auto;
                animation: pulseAnimation 2s infinite;
            }

            .scroll-to-wishes-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                transition: left 0.6s ease;
            }

            .scroll-to-wishes-btn:hover::before {
                left: 100%;
            }

            .scroll-to-wishes-btn:hover {
                transform: translateY(-3px);
                background: linear-gradient(135deg, #9baa8a, #7b8579);
                box-shadow: 
                    0 10px 30px rgba(107, 117, 105, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                animation: none;
            }

            .scroll-to-wishes-btn:active {
                transform: translateY(-1px);
            }

            .scroll-to-wishes-btn svg {
                transition: transform 0.3s ease;
            }

            .scroll-to-wishes-btn:hover svg {
                transform: translateY(3px);
            }

            @keyframes pulseAnimation {
                0% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
                50% {
                    transform: scale(1.05);
                    box-shadow: 0 8px 25px rgba(107, 117, 105, 0.4);
                }
                100% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
            }

            /* ANİMASYONLAR */
            @keyframes titleFadeIn {
                from {
                    opacity: 0;
                    transform: translateY(-20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes lineExpand {
                to {
                    transform: scaleX(1);
                }
            }

            @keyframes cardSlideIn {
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes mapSlideIn {
                to {
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            /* RESPONSİVE TASARIM */
            @media (max-width: 1024px) {
                .wedding-map-frame {
                    height: 300px;
                }
            }

            @media (max-width: 768px) {
                .wedding-info-card {
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 16px;
                    padding: 20px;
                }

                .wedding-info-icon {
                    width: 56px;
                    height: 56px;
                }

                .wedding-map-frame {
                    height: 250px;
                }

                .wedding-map-container {
                    padding: 20px;
                }
            }

            @media (max-width: 640px) {
                .wedding-info-title {
                    font-size: 2.5rem !important;
                }

                .wedding-info-card {
                    padding: 16px;
                }

                .wedding-info-card-title {
                    font-size: 1.5rem;
                }

                .wedding-directions-btn {
                    padding: 16px 24px;
                }

                .wedding-contact-link {
                    padding: 10px 16px;
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 480px) {
                .wedding-info-title {
                    font-size: 2rem !important;
                }

                .wedding-map-frame {
                    height: 200px;
                }

                .wedding-map-container {
                    padding: 16px;
                }
            }

            /* LÜKS MEKTUP TASARIMI STİLLERİ */
            .luxury-letter-container {
                position: relative;
                max-width: 800px;
                margin: 0 auto;
                transform-style: preserve-3d;
                transition: all 0.6s ease;
                padding: 10px;
            }

            .luxury-letter-container:hover {
                transform: translateY(-5px);
            }

            .luxury-letter-decorations {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                pointer-events: none;
                z-index: 20;
            }

            .luxury-letter-corner {
                position: absolute;
                width: 30px;
                height: 30px;
                z-index: 30;
            }

            .luxury-letter-corner.top-left {
                top: 0;
                left: 0;
                border-top: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-top-left-radius: 8px;
            }

            .luxury-letter-corner.top-right {
                top: 0;
                right: 0;
                border-top: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-top-right-radius: 8px;
            }

            .luxury-letter-corner.bottom-left {
                bottom: 0;
                left: 0;
                border-bottom: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-bottom-left-radius: 8px;
            }

            .luxury-letter-corner.bottom-right {
                bottom: 0;
                right: 0;
                border-bottom: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-bottom-right-radius: 8px;
            }

            .luxury-letter-edge {
                position: absolute;
                z-index: 25;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
                opacity: 0.5;
            }

            .luxury-letter-edge.top {
                top: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.bottom {
                bottom: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.left {
                left: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-edge.right {
                right: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-content {
                background: #fff;
                padding: 40px 30px;
                border-radius: 8px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 3px 10px rgba(0, 0, 0, 0.02),
                    inset 0 0 0 1px rgba(239, 163, 139, 0.1);
                position: relative;
                z-index: 10;
                overflow: hidden;
            }

            .luxury-letter-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-ornament {
                flex-shrink: 0;
                opacity: 0.7;
                transition: all 0.5s ease;
            }

            .luxury-letter-container:hover .luxury-letter-ornament {
                opacity: 1;
                transform: scale(1.1);
            }

            .luxury-letter-title {
                flex: 1;
                text-align: center;
                position: relative;
                padding: 0 20px;
            }

            .luxury-letter-title h3 {
                font-family: 'Dancing Script', cursive;
                font-size: 2.8rem;
                font-weight: 600;
                color: #8b9a7a;
                margin: 0 0 10px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .luxury-letter-title-underline {
                height: 2px;
                width: 70%;
                margin: 0 auto;
                background: linear-gradient(to right, transparent, #efa38b, transparent);
            }

            .luxury-letter-body {
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-textarea {
                width: 100%;
                min-height: 150px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                border-radius: 6px;
                padding: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                color: #575956;
                background: rgba(255, 255, 255, 0.8);
                resize: none;
                transition: all 0.3s ease;
                line-height: 1.7;
                box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);
            }

            .luxury-letter-textarea:focus {
                outline: none;
                border-color: rgba(239, 163, 139, 0.4);
                box-shadow: 0 0 0 2px rgba(239, 163, 139, 0.1);
            }

            .luxury-letter-textarea::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-style: italic;
            }

            .luxury-letter-footer {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-top: 20px;
            }

            .luxury-letter-signature {
                width: 200px;
                position: relative;
            }

            .luxury-letter-signature-input {
                width: 100%;
                border: none;
                background: transparent;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #575956;
                padding: 5px 0;
                text-align: center;
            }

            .luxury-letter-signature-input:focus {
                outline: none;
            }

            .luxury-letter-signature-input::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-size: 1.1rem;
            }

            .luxury-letter-signature-line {
                width: 100%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(87, 89, 86, 0.2), transparent);
                margin-top: 5px;
            }

            .luxury-letter-download-btn {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 12px 24px;
                background: #efa38b;
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(239, 163, 139, 0.2);
            }

            .luxury-letter-download-btn::before {
                content: none;
            }

            .luxury-letter-download-btn:hover {
                transform: translateY(-2px);
                background: #f0b49c;
                box-shadow: 0 6px 16px rgba(239, 163, 139, 0.3);
            }

            .luxury-letter-download-btn:active {
                transform: translateY(0);
            }

            .luxury-letter-download-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: transform 0.3s ease;
            }

            .luxury-letter-download-btn:hover .luxury-letter-download-icon {
                transform: translateY(2px);
            }

            /* Altın Süslemeli Ayraç */
            .luxury-divider {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 60px 0;
                position: relative;
            }

            .luxury-divider-line {
                height: 1px;
                flex: 1;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
            }

            .luxury-divider-line.left {
                background: linear-gradient(to right, transparent, #d4a98a);
            }

            .luxury-divider-line.right {
                background: linear-gradient(to right, #d4a98a, transparent);
            }

            .luxury-divider-ornament {
                margin: 0 20px;
                color: #d4a98a;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: rotate(0deg);
                transition: transform 1s ease;
            }

            .luxury-divider:hover .luxury-divider-ornament {
                transform: rotate(360deg);
            }

            /* Dilek Kartları */
            .luxury-wish-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 5px 10px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
            }

            .luxury-wish-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 5px;
                background: linear-gradient(to right, #efa38b, #d4a98a);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .luxury-wish-card:hover {
                transform: translateY(-10px);
                box-shadow: 
                    0 20px 40px rgba(0, 0, 0, 0.1),
                    0 10px 15px rgba(0, 0, 0, 0.03);
            }

            .luxury-wish-card-content {
                background: #fff;
                border-radius: 10px;
                padding: 25px;
                border: 1px solid rgba(139, 154, 122, 0.1);
            }

            .luxury-wish-text {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #575956;
                margin-bottom: 20px;
                font-style: italic;
            }

            .luxury-wish-signature {
                text-align: right;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #8b9a7a;
                position: relative;
            }

            .luxury-wish-signature::before {
                content: '';
                position: absolute;
                bottom: -5px;
                right: 0;
                width: 50%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(139, 154, 122, 0.3));
            }

            /* Mektup bölümü responsive tasarım */
            @media (max-width: 768px) {
                .luxury-letter-content {
                    padding: 40px 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2.5rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 60px;
                    height: 60px;
                }
                
                .luxury-letter-textarea {
                    padding: 20px;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 640px) {
                .luxury-letter-content {
                    padding: 30px 20px;
                }
                
                .luxury-letter-header {
                    margin-bottom: 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 50px;
                    height: 50px;
                }
                
                .luxury-letter-textarea {
                    padding: 15px;
                    font-size: 1rem;
                }
                
                .luxury-letter-footer {
                    flex-direction: column;
                    gap: 25px;
                    align-items: center;
                }
                
                .luxury-letter-signature {
                    width: 80%;
                    margin-bottom: 10px;
                }
                
                .luxury-letter-download-btn {
                    width: 100%;
                    justify-content: center;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.85rem;
                }
                
                .luxury-wish-card-content {
                    padding: 20px;
                }
            }

            @media (max-width: 480px) {
                .luxury-letter-content {
                    padding: 25px 15px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 1.75rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 40px;
                    height: 40px;
                }
                
                .luxury-letter-signature-input {
                    font-size: 1.3rem;
                }
                
                .luxury-letter-download-btn {
                    padding: 12px 20px;
                }
                
                .luxury-divider-ornament {
                    margin: 0 10px;
                }
                
                .luxury-divider-ornament svg {
                    width: 30px;
                    height: 30px;
                }
            }

            /* HAZIR DİLEK ŞABLONLARI STİLLERİ */
            .wish-template-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 8px 20px rgba(0, 0, 0, 0.05),
                    0 3px 8px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
                cursor: pointer;
                margin-bottom: 20px;
            }

            .wish-template-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(to right, #8b9a7a, #efa38b);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .wish-template-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 15px 30px rgba(0, 0, 0, 0.1),
                    0 8px 12px rgba(0, 0, 0, 0.03);
            }

            .wish-template-content {
                background: #fff;
                border-radius: 10px;
                padding: 20px;
                border: 1px solid rgba(139, 154, 122, 0.1);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .wish-template-preview {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                line-height: 1.6;
                color: #575956;
                margin-bottom: 15px;
                font-style: italic;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .wish-template-button {
                text-align: center;
                margin-top: auto;
            }

            .wish-template-button span {
                display: inline-block;
                padding: 8px 16px;
                background: rgba(139, 154, 122, 0.1);
                color: #8b9a7a;
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                font-weight: 600;
                transition: all 0.3s ease;
            }

            .wish-template-card:hover .wish-template-button span {
                background: #8b9a7a;
                color: white;
                border-color: #8b9a7a;
            }

            @media (max-width: 768px) {
                .wish-template-preview {
                    -webkit-line-clamp: 4;
                    font-size: 0.85rem;
                }
                
                .wish-template-button span {
                    padding: 7px 14px;
                    font-size: 0.8rem;
                }
            }

            @media (max-width: 640px) {
                .wish-template-preview {
                    -webkit-line-clamp: 3;
                }
            }

            /* YENİ FOOTER STİLLERİ - GÖRSELDEKİ GİBİ */
            .wedding-footer-new {
                background-color: rgba(139, 154, 122, 0.95); /* Görseldeki yeşil ton - tek renk */
                color: #fff;
                padding: 60px 0 30px;
                position: relative;
                z-index: 50;
                text-align: center;
                border-top: 1px solid rgba(255, 255, 255, 0.2);
            }

            .wedding-footer-center {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 20px;
            }

            .wedding-footer-heart-icon {
                width: 60px;
                height: 60px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto 20px;
                color: white;
            }

            .wedding-footer-couple {
                font-family: 'Dancing Script', cursive;
                font-size: 3.5rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 25px;
                text-align: center;
            }

            .wedding-footer-message {
                max-width: 800px;
                margin: 0 auto 50px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                line-height: 1.7;
                color: #fff;
                text-align: center;
                padding: 0 20px;
            }

            .wedding-footer-columns {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 80px;
                margin-bottom: 50px;
            }

            .wedding-footer-column {
                flex: 1;
                min-width: 250px;
                max-width: 450px;
                text-align: left;
            }

            .wedding-footer-subtitle {
                font-family: 'Dancing Script', cursive;
                font-size: 2rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 20px;
                text-align: left;
            }

            .wedding-footer-contact-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
            }

            .wedding-footer-icon-circle {
                width: 36px;
                height: 36px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 15px;
                flex-shrink: 0;
            }

            .wedding-footer-witness {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #fff;
                text-align: left;
            }

            .wedding-footer-divider-new {
                height: 1px;
                background: rgba(255, 255, 255, 0.2);
                margin: 30px auto;
                width: 100%;
                max-width: 900px;
            }

            .wedding-footer-bottom-new {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
            }

            .wedding-footer-copyright-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-quote {
                font-family: 'Dancing Script', cursive;
                font-size: 1.1rem;
                font-style: italic;
                color: rgba(255, 255, 255, 0.8);
                margin: 10px 0;
            }

            .wedding-footer-credit-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-credit-new span {
                color: #efa38b;
                font-weight: 600;
            }

            @media (max-width: 768px) {
                .wedding-footer-new {
                    padding: 40px 0 20px;
                }
                
                .wedding-footer-couple {
                    font-size: 2.8rem;
                }
                
                .wedding-footer-message {
                    font-size: 1rem;
                    margin-bottom: 40px;
                }
                
                .wedding-footer-columns {
                    flex-direction: column;
                    gap: 40px;
                    align-items: center;
                }
                
                .wedding-footer-column {
                    width: 100%;
                    max-width: 100%;
                    text-align: center;
                }
                
                .wedding-footer-subtitle {
                    text-align: center;
                    font-size: 1.8rem;
                }
                
                .wedding-footer-contact-item {
                    justify-content: center;
                }
                
                .wedding-footer-witness {
                    text-align: center;
                }
            }

            @media (max-width: 480px) {
                .wedding-footer-couple {
                    font-size: 2.2rem;
                }
                
                .wedding-footer-message {
                    font-size: 0.9rem;
                }
                
                .wedding-footer-subtitle {
                    font-size: 1.6rem;
                }
                
                .wedding-footer-heart-icon {
                    width: 50px;
                    height: 50px;
                }
            }

            /* Çiçek Süsleme Animasyonu */
            .flower-ornament {
                width: 60px;
                height: 60px;
                object-fit: contain;
                animation: flowerSway 6s ease-in-out infinite;
            }

            .luxury-letter-ornament.right .flower-ornament {
                transform: scaleX(-1); /* Sağdaki çiçeği simetri için çevir */
            }

            .luxury-letter-ornament.left .flower-ornament {
                animation-delay: 0.5s;
            }

            @keyframes flowerSway {
                0%, 100% {
                    transform: rotate(-8deg) scale(1);
                }
                50% {
                    transform: rotate(8deg) scale(1.05);
                }
            }
            .luxury-letter-ornament.right .flower-ornament {
                animation-name: flowerSwayRight;
            }
            @keyframes flowerSwayRight {
                0%, 100% {
                    transform: scaleX(-1) rotate(-8deg) scale(1);
                }
                50% {
                    transform: scaleX(-1) rotate(8deg) scale(1.05);
                }
            }


            /* Yüksek çözünürlüklü ekranlar için */
            @media (min-width: 1920px) {
                .absolute.inset-0 {
                    background-size: 100% auto !important;
                    background-position: center center !important;
                }
            }

            /* Retina ekranlar için optimizasyon */
            @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
                .absolute.inset-0 {
                    background-size: cover !important;
                }
            }

            /* İsimler Konteyner */
            .names-container {
                position: relative;
                overflow: visible;
                white-space: nowrap;
            }
            
            /* Çift İsimleri Stilı - Görseldeki gibi */
            .first-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromLeft 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(-100px);
            }
            
            .ampersand {
                font-family: 'Dancing Script', cursive;
                font-weight: 500;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                display: inline-block;
                position: relative;
                animation: brushAppear 1s ease-in-out 1.2s forwards;
                opacity: 0;
            }
            
            .second-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromRight 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(100px);
            }
            
            /* İsim Animasyonları */
            @keyframes slideFromLeft {
                0% {
                    transform: translateX(-100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes slideFromRight {
                0% {
                    transform: translateX(100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes brushAppear {
                0% {
                    opacity: 0;
                    transform: scale(0.5) rotate(-10deg);
                    filter: blur(10px);
                }
                30% {
                    opacity: 0.7;
                    transform: scale(1.2) rotate(5deg);
                    filter: blur(3px);
                }
                60% {
                    transform: scale(0.9) rotate(-3deg);
                    filter: blur(0px);
                }
                80% {
                    transform: scale(1.05) rotate(2deg);
                }
                100% {
                    opacity: 1;
                    transform: scale(1) rotate(0deg);
                }
            }
            
            /* Ampersand fırça efekti - Dairesel efekt */
            .ampersand::before, .ampersand::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                background: radial-gradient(circle, rgba(239, 163, 139, 0.2) 0%, rgba(239, 163, 139, 0) 70%);
                border-radius: 50%;
                z-index: -1;
                transform: translate(-50%, -50%) scale(0);
                animation: brushSplash 1.5s ease-out 1.3s forwards;
                pointer-events: none;
            }
            
            .ampersand::after {
                background: radial-gradient(circle, rgba(239, 163, 139, 0.1) 0%, rgba(239, 163, 139, 0) 70%);
                animation-delay: 1.4s;
                animation-duration: 2s;
            }
            
            @keyframes brushSplash {
                0% {
                    transform: translate(-50%, -50%) scale(0);
                    opacity: 0.8;
                }
                100% {
                    transform: translate(-50%, -50%) scale(2.5);
                    opacity: 0;
                }
            }
            
            /* Hover efektleri */
            .first-name:hover, .second-name:hover {
                transform: scale(1.02);
                text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
                transition: all 0.3s ease;
            }
            
            /* Mobil cihazlarda font boyutunu ayarla */
            @media (max-width: 640px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 1px;
                    font-size: 3.5rem !important;
                }
            }
            
            @media (max-width: 480px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 0.5px;
                    font-size: 3rem !important;
                }
            }
            
            /* Davetiye metni stili */
            .invitation-text {
                font-family: 'Nunito', sans-serif;
                color: #575956;
                font-weight: 400;
                line-height: 1.6;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
                opacity: 0.9;
                animation: fadeIn 1s ease-in-out;
            }
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 0.9; transform: translateY(0); }
            }

            /* DÜĞÜN BİLGİLERİ BÖLÜMÜ STİLLERİ */
            .wedding-info-title {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                animation: titleFadeIn 1s ease-out;
            }

            .wedding-info-line {
                width: 100px;
                height: 3px;
                background: linear-gradient(90deg, #efa38b, #8b9a7a);
                border-radius: 2px;
                animation: lineExpand 1.2s ease-out 0.3s forwards;
                transform: scaleX(0);
            }

            .wedding-info-card {
                display: flex;
                align-items: flex-start;
                gap: 20px;
                padding: 24px;
                background: rgba(255, 255, 255, 0.7);
                backdrop-filter: blur(20px);
                border-radius: 20px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                transition: all 0.3s ease;
                animation: cardSlideIn 0.8s ease-out forwards;
                opacity: 0;
                transform: translateY(30px);
            }

            .wedding-info-card:nth-child(1) { animation-delay: 0.2s; }
            .wedding-info-card:nth-child(2) { animation-delay: 0.4s; }
            .wedding-info-card:nth-child(3) { animation-delay: 0.6s; }

            .wedding-info-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 16px 48px rgba(0, 0, 0, 0.12),
                    inset 0 1px 0 rgba(255, 255, 255, 0.8);
                border-color: rgba(239, 163, 139, 0.4);
            }

            .wedding-info-icon {
                flex-shrink: 0;
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 50%;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
            }

            .wedding-info-card:hover .wedding-info-icon {
                transform: scale(1.1);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
            }

            .wedding-info-content {
                flex: 1;
            }

            .wedding-info-card-title {
                font-family: 'Dancing Script', cursive;
                font-size: 1.75rem;
                font-weight: 600;
                margin-bottom: 8px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .wedding-info-card-text {
                font-family: 'Nunito', sans-serif;
                line-height: 1.6;
            }

            /* YOL TARİFİ BUTONU */
            .wedding-directions-btn {
                padding: 18px 32px;
                background: linear-gradient(135deg, #efa38b, #d4a98a);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 8px 24px rgba(239, 163, 139, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
            }

            .wedding-directions-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                transition: left 0.6s ease;
            }

            .wedding-directions-btn:hover::before {
                left: 100%;
            }

            .wedding-directions-btn:hover {
                transform: translateY(-3px);
                box-shadow: 
                    0 12px 36px rgba(239, 163, 139, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                background: linear-gradient(135deg, #f0b49c, #d9b59a);
            }

            .wedding-directions-btn:active {
                transform: translateY(-1px);
            }

            /* HARİTA KONTEYNER */
            .wedding-map-container {
                background: rgba(255, 255, 255, 0.8);
                backdrop-filter: blur(20px);
                border-radius: 25px;
                padding: 24px;
                border: 1px solid rgba(139, 154, 122, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                animation: mapSlideIn 1s ease-out 0.8s forwards;
                opacity: 0;
                transform: translateX(50px);
            }

            .wedding-map-header {
                margin-bottom: 20px;
                text-align: center;
            }

            .wedding-map-frame {
                width: 100%;
                height: 350px;
                border-radius: 15px;
                overflow: hidden;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                margin-bottom: 16px;
            }

            .wedding-map-footer {
                padding: 16px;
                background: rgba(255, 255, 255, 0.6);
                border-radius: 12px;
                border: 1px solid rgba(239, 163, 139, 0.15);
            }

            .wedding-map-btn {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border: 1px solid currentColor;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease;
            }

            .wedding-map-btn:hover {
                background: currentColor;
                color: white !important;
                transform: scale(1.1);
            }

            /* İLETİŞİM LİNKLERİ */
            .wedding-contact-link {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 20px;
                background: rgba(255, 255, 255, 0.6);
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 25px;
                color: #575956;
                text-decoration: none;
                font-family: 'Nunito', sans-serif;
                font-weight: 500;
                transition: all 0.3s ease;
            }

            .wedding-contact-link:hover {
                background: rgba(139, 154, 122, 0.1);
                border-color: rgba(139, 154, 122, 0.5);
                transform: translateY(-2px);
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            }

            /* Mektup bölümüne kaydırma butonu */
            .scroll-to-wishes-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                padding: 14px 28px;
                background: linear-gradient(135deg, #8b9a7a, #6b7569);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 6px 20px rgba(107, 117, 105, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
                margin: 0 auto;
                animation: pulseAnimation 2s infinite;
            }

            .scroll-to-wishes-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                transition: left 0.6s ease;
            }

            .scroll-to-wishes-btn:hover::before {
                left: 100%;
            }

            .scroll-to-wishes-btn:hover {
                transform: translateY(-3px);
                background: linear-gradient(135deg, #9baa8a, #7b8579);
                box-shadow: 
                    0 10px 30px rgba(107, 117, 105, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                animation: none;
            }

            .scroll-to-wishes-btn:active {
                transform: translateY(-1px);
            }

            .scroll-to-wishes-btn svg {
                transition: transform 0.3s ease;
            }

            .scroll-to-wishes-btn:hover svg {
                transform: translateY(3px);
            }

            @keyframes pulseAnimation {
                0% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
                50% {
                    transform: scale(1.05);
                    box-shadow: 0 8px 25px rgba(107, 117, 105, 0.4);
                }
                100% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
            }

            /* ANİMASYONLAR */
            @keyframes titleFadeIn {
                from {
                    opacity: 0;
                    transform: translateY(-20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes lineExpand {
                to {
                    transform: scaleX(1);
                }
            }

            @keyframes cardSlideIn {
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes mapSlideIn {
                to {
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            /* RESPONSİVE TASARIM */
            @media (max-width: 1024px) {
                .wedding-map-frame {
                    height: 300px;
                }
            }

            @media (max-width: 768px) {
                .wedding-info-card {
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 16px;
                    padding: 20px;
                }

                .wedding-info-icon {
                    width: 56px;
                    height: 56px;
                }

                .wedding-map-frame {
                    height: 250px;
                }

                .wedding-map-container {
                    padding: 20px;
                }
            }

            @media (max-width: 640px) {
                .wedding-info-title {
                    font-size: 2.5rem !important;
                }

                .wedding-info-card {
                    padding: 16px;
                }

                .wedding-info-card-title {
                    font-size: 1.5rem;
                }

                .wedding-directions-btn {
                    padding: 16px 24px;
                }

                .wedding-contact-link {
                    padding: 10px 16px;
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 480px) {
                .wedding-info-title {
                    font-size: 2rem !important;
                }

                .wedding-map-frame {
                    height: 200px;
                }

                .wedding-map-container {
                    padding: 16px;
                }
            }

            /* LÜKS MEKTUP TASARIMI STİLLERİ */
            .luxury-letter-container {
                position: relative;
                max-width: 800px;
                margin: 0 auto;
                transform-style: preserve-3d;
                transition: all 0.6s ease;
                padding: 10px;
            }

            .luxury-letter-container:hover {
                transform: translateY(-5px);
            }

            .luxury-letter-decorations {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                pointer-events: none;
                z-index: 20;
            }

            .luxury-letter-corner {
                position: absolute;
                width: 30px;
                height: 30px;
                z-index: 30;
            }

            .luxury-letter-corner.top-left {
                top: 0;
                left: 0;
                border-top: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-top-left-radius: 8px;
            }

            .luxury-letter-corner.top-right {
                top: 0;
                right: 0;
                border-top: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-top-right-radius: 8px;
            }

            .luxury-letter-corner.bottom-left {
                bottom: 0;
                left: 0;
                border-bottom: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-bottom-left-radius: 8px;
            }

            .luxury-letter-corner.bottom-right {
                bottom: 0;
                right: 0;
                border-bottom: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-bottom-right-radius: 8px;
            }

            .luxury-letter-edge {
                position: absolute;
                z-index: 25;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
                opacity: 0.5;
            }

            .luxury-letter-edge.top {
                top: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.bottom {
                bottom: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.left {
                left: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-edge.right {
                right: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-content {
                background: #fff;
                padding: 40px 30px;
                border-radius: 8px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 3px 10px rgba(0, 0, 0, 0.02),
                    inset 0 0 0 1px rgba(239, 163, 139, 0.1);
                position: relative;
                z-index: 10;
                overflow: hidden;
            }

            .luxury-letter-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-ornament {
                flex-shrink: 0;
                opacity: 0.7;
                transition: all 0.5s ease;
            }

            .luxury-letter-container:hover .luxury-letter-ornament {
                opacity: 1;
                transform: scale(1.1);
            }

            .luxury-letter-title {
                flex: 1;
                text-align: center;
                position: relative;
                padding: 0 20px;
            }

            .luxury-letter-title h3 {
                font-family: 'Dancing Script', cursive;
                font-size: 2.8rem;
                font-weight: 600;
                color: #8b9a7a;
                margin: 0 0 10px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .luxury-letter-title-underline {
                height: 2px;
                width: 70%;
                margin: 0 auto;
                background: linear-gradient(to right, transparent, #efa38b, transparent);
            }

            .luxury-letter-body {
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-textarea {
                width: 100%;
                min-height: 150px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                border-radius: 6px;
                padding: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                color: #575956;
                background: rgba(255, 255, 255, 0.8);
                resize: none;
                transition: all 0.3s ease;
                line-height: 1.7;
                box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);
            }

            .luxury-letter-textarea:focus {
                outline: none;
                border-color: rgba(239, 163, 139, 0.4);
                box-shadow: 0 0 0 2px rgba(239, 163, 139, 0.1);
            }

            .luxury-letter-textarea::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-style: italic;
            }

            .luxury-letter-footer {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-top: 20px;
            }

            .luxury-letter-signature {
                width: 200px;
                position: relative;
            }

            .luxury-letter-signature-input {
                width: 100%;
                border: none;
                background: transparent;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #575956;
                padding: 5px 0;
                text-align: center;
            }

            .luxury-letter-signature-input:focus {
                outline: none;
            }

            .luxury-letter-signature-input::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-size: 1.1rem;
            }

            .luxury-letter-signature-line {
                width: 100%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(87, 89, 86, 0.2), transparent);
                margin-top: 5px;
            }

            .luxury-letter-download-btn {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 12px 24px;
                background: #efa38b;
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(239, 163, 139, 0.2);
            }

            .luxury-letter-download-btn::before {
                content: none;
            }

            .luxury-letter-download-btn:hover {
                transform: translateY(-2px);
                background: #f0b49c;
                box-shadow: 0 6px 16px rgba(239, 163, 139, 0.3);
            }

            .luxury-letter-download-btn:active {
                transform: translateY(0);
            }

            .luxury-letter-download-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: transform 0.3s ease;
            }

            .luxury-letter-download-btn:hover .luxury-letter-download-icon {
                transform: translateY(2px);
            }

            /* Altın Süslemeli Ayraç */
            .luxury-divider {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 60px 0;
                position: relative;
            }

            .luxury-divider-line {
                height: 1px;
                flex: 1;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
            }

            .luxury-divider-line.left {
                background: linear-gradient(to right, transparent, #d4a98a);
            }

            .luxury-divider-line.right {
                background: linear-gradient(to right, #d4a98a, transparent);
            }

            .luxury-divider-ornament {
                margin: 0 20px;
                color: #d4a98a;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: rotate(0deg);
                transition: transform 1s ease;
            }

            .luxury-divider:hover .luxury-divider-ornament {
                transform: rotate(360deg);
            }

            /* Dilek Kartları */
            .luxury-wish-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 5px 10px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
            }

            .luxury-wish-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 5px;
                background: linear-gradient(to right, #efa38b, #d4a98a);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .luxury-wish-card:hover {
                transform: translateY(-10px);
                box-shadow: 
                    0 20px 40px rgba(0, 0, 0, 0.1),
                    0 10px 15px rgba(0, 0, 0, 0.03);
            }

            .luxury-wish-card-content {
                background: #fff;
                border-radius: 10px;
                padding: 25px;
                border: 1px solid rgba(139, 154, 122, 0.1);
            }

            .luxury-wish-text {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #575956;
                margin-bottom: 20px;
                font-style: italic;
            }

            .luxury-wish-signature {
                text-align: right;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #8b9a7a;
                position: relative;
            }

            .luxury-wish-signature::before {
                content: '';
                position: absolute;
                bottom: -5px;
                right: 0;
                width: 50%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(139, 154, 122, 0.3));
            }

            /* Mektup bölümü responsive tasarım */
            @media (max-width: 768px) {
                .luxury-letter-content {
                    padding: 40px 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2.5rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 60px;
                    height: 60px;
                }
                
                .luxury-letter-textarea {
                    padding: 20px;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 640px) {
                .luxury-letter-content {
                    padding: 30px 20px;
                }
                
                .luxury-letter-header {
                    margin-bottom: 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 50px;
                    height: 50px;
                }
                
                .luxury-letter-textarea {
                    padding: 15px;
                    font-size: 1rem;
                }
                
                .luxury-letter-footer {
                    flex-direction: column;
                    gap: 25px;
                    align-items: center;
                }
                
                .luxury-letter-signature {
                    width: 80%;
                    margin-bottom: 10px;
                }
                
                .luxury-letter-download-btn {
                    width: 100%;
                    justify-content: center;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.85rem;
                }
                
                .luxury-wish-card-content {
                    padding: 20px;
                }
            }

            @media (max-width: 480px) {
                .luxury-letter-content {
                    padding: 25px 15px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 1.75rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 40px;
                    height: 40px;
                }
                
                .luxury-letter-signature-input {
                    font-size: 1.3rem;
                }
                
                .luxury-letter-download-btn {
                    padding: 12px 20px;
                }
                
                .luxury-divider-ornament {
                    margin: 0 10px;
                }
                
                .luxury-divider-ornament svg {
                    width: 30px;
                    height: 30px;
                }
            }

            /* HAZIR DİLEK ŞABLONLARI STİLLERİ */
            .wish-template-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 8px 20px rgba(0, 0, 0, 0.05),
                    0 3px 8px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
                cursor: pointer;
                margin-bottom: 20px;
            }

            .wish-template-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(to right, #8b9a7a, #efa38b);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .wish-template-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 15px 30px rgba(0, 0, 0, 0.1),
                    0 8px 12px rgba(0, 0, 0, 0.03);
            }

            .wish-template-content {
                background: #fff;
                border-radius: 10px;
                padding: 20px;
                border: 1px solid rgba(139, 154, 122, 0.1);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .wish-template-preview {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                line-height: 1.6;
                color: #575956;
                margin-bottom: 15px;
                font-style: italic;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .wish-template-button {
                text-align: center;
                margin-top: auto;
            }

            .wish-template-button span {
                display: inline-block;
                padding: 8px 16px;
                background: rgba(139, 154, 122, 0.1);
                color: #8b9a7a;
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                font-weight: 600;
                transition: all 0.3s ease;
            }

            .wish-template-card:hover .wish-template-button span {
                background: #8b9a7a;
                color: white;
                border-color: #8b9a7a;
            }

            @media (max-width: 768px) {
                .wish-template-preview {
                    -webkit-line-clamp: 4;
                    font-size: 0.85rem;
                }
                
                .wish-template-button span {
                    padding: 7px 14px;
                    font-size: 0.8rem;
                }
            }

            @media (max-width: 640px) {
                .wish-template-preview {
                    -webkit-line-clamp: 3;
                }
            }

            /* YENİ FOOTER STİLLERİ - GÖRSELDEKİ GİBİ */
            .wedding-footer-new {
                background-color: rgba(139, 154, 122, 0.95); /* Görseldeki yeşil ton - tek renk */
                color: #fff;
                padding: 60px 0 30px;
                position: relative;
                z-index: 50;
                text-align: center;
                border-top: 1px solid rgba(255, 255, 255, 0.2);
            }

            .wedding-footer-center {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 20px;
            }

            .wedding-footer-heart-icon {
                width: 60px;
                height: 60px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto 20px;
                color: white;
            }

            .wedding-footer-couple {
                font-family: 'Dancing Script', cursive;
                font-size: 3.5rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 25px;
                text-align: center;
            }

            .wedding-footer-message {
                max-width: 800px;
                margin: 0 auto 50px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                line-height: 1.7;
                color: #fff;
                text-align: center;
                padding: 0 20px;
            }

            .wedding-footer-columns {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 80px;
                margin-bottom: 50px;
            }

            .wedding-footer-column {
                flex: 1;
                min-width: 250px;
                max-width: 450px;
                text-align: left;
            }

            .wedding-footer-subtitle {
                font-family: 'Dancing Script', cursive;
                font-size: 2rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 20px;
                text-align: left;
            }

            .wedding-footer-contact-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
            }

            .wedding-footer-icon-circle {
                width: 36px;
                height: 36px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 15px;
                flex-shrink: 0;
            }

            .wedding-footer-witness {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #fff;
                text-align: left;
            }

            .wedding-footer-divider-new {
                height: 1px;
                background: rgba(255, 255, 255, 0.2);
                margin: 30px auto;
                width: 100%;
                max-width: 900px;
            }

            .wedding-footer-bottom-new {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
            }

            .wedding-footer-copyright-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-quote {
                font-family: 'Dancing Script', cursive;
                font-size: 1.1rem;
                font-style: italic;
                color: rgba(255, 255, 255, 0.8);
                margin: 10px 0;
            }

            .wedding-footer-credit-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-credit-new span {
                color: #efa38b;
                font-weight: 600;
            }

            @media (max-width: 768px) {
                .wedding-footer-new {
                    padding: 40px 0 20px;
                }
                
                .wedding-footer-couple {
                    font-size: 2.8rem;
                }
                
                .wedding-footer-message {
                    font-size: 1rem;
                    margin-bottom: 40px;
                }
                
                .wedding-footer-columns {
                    flex-direction: column;
                    gap: 40px;
                    align-items: center;
                }
                
                .wedding-footer-column {
                    width: 100%;
                    max-width: 100%;
                    text-align: center;
                }
                
                .wedding-footer-subtitle {
                    text-align: center;
                    font-size: 1.8rem;
                }
                
                .wedding-footer-contact-item {
                    justify-content: center;
                }
                
                .wedding-footer-witness {
                    text-align: center;
                }
            }

            @media (max-width: 480px) {
                .wedding-footer-couple {
                    font-size: 2.2rem;
                }
                
                .wedding-footer-message {
                    font-size: 0.9rem;
                }
                
                .wedding-footer-subtitle {
                    font-size: 1.6rem;
                }
                
                .wedding-footer-heart-icon {
                    width: 50px;
                    height: 50px;
                }
            }

            /* Çiçek Süsleme Animasyonu */
            .flower-ornament {
                width: 60px;
                height: 60px;
                object-fit: contain;
                animation: flowerSway 6s ease-in-out infinite;
            }

            .luxury-letter-ornament.right .flower-ornament {
                transform: scaleX(-1); /* Sağdaki çiçeği simetri için çevir */
            }

            .luxury-letter-ornament.left .flower-ornament {
                animation-delay: 0.5s;
            }

            @keyframes flowerSway {
                0%, 100% {
                    transform: rotate(-8deg) scale(1);
                }
                50% {
                    transform: rotate(8deg) scale(1.05);
                }
            }
            .luxury-letter-ornament.right .flower-ornament {
                animation-name: flowerSwayRight;
            }
            @keyframes flowerSwayRight {
                0%, 100% {
                    transform: scaleX(-1) rotate(-8deg) scale(1);
                }
                50% {
                    transform: scaleX(-1) rotate(8deg) scale(1.05);
                }
            }


            /* Yüksek çözünürlüklü ekranlar için */
            @media (min-width: 1920px) {
                .absolute.inset-0 {
                    background-size: 100% auto !important;
                    background-position: center center !important;
                }
            }

            /* Retina ekranlar için optimizasyon */
            @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
                .absolute.inset-0 {
                    background-size: cover !important;
                }
            }

            /* İsimler Konteyner */
            .names-container {
                position: relative;
                overflow: visible;
                white-space: nowrap;
            }
            
            /* Çift İsimleri Stilı - Görseldeki gibi */
            .first-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromLeft 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(-100px);
            }
            
            .ampersand {
                font-family: 'Dancing Script', cursive;
                font-weight: 500;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                display: inline-block;
                position: relative;
                animation: brushAppear 1s ease-in-out 1.2s forwards;
                opacity: 0;
            }
            
            .second-name {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                font-style: italic;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                letter-spacing: 1px;
                display: inline-block;
                animation: slideFromRight 1.5s ease-out forwards;
                opacity: 0;
                transform: translateX(100px);
            }
            
            /* İsim Animasyonları */
            @keyframes slideFromLeft {
                0% {
                    transform: translateX(-100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes slideFromRight {
                0% {
                    transform: translateX(100px);
                    opacity: 0;
                }
                30% {
                    opacity: 0.3;
                }
                100% {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes brushAppear {
                0% {
                    opacity: 0;
                    transform: scale(0.5) rotate(-10deg);
                    filter: blur(10px);
                }
                30% {
                    opacity: 0.7;
                    transform: scale(1.2) rotate(5deg);
                    filter: blur(3px);
                }
                60% {
                    transform: scale(0.9) rotate(-3deg);
                    filter: blur(0px);
                }
                80% {
                    transform: scale(1.05) rotate(2deg);
                }
                100% {
                    opacity: 1;
                    transform: scale(1) rotate(0deg);
                }
            }
            
            /* Ampersand fırça efekti - Dairesel efekt */
            .ampersand::before, .ampersand::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                background: radial-gradient(circle, rgba(239, 163, 139, 0.2) 0%, rgba(239, 163, 139, 0) 70%);
                border-radius: 50%;
                z-index: -1;
                transform: translate(-50%, -50%) scale(0);
                animation: brushSplash 1.5s ease-out 1.3s forwards;
                pointer-events: none;
            }
            
            .ampersand::after {
                background: radial-gradient(circle, rgba(239, 163, 139, 0.1) 0%, rgba(239, 163, 139, 0) 70%);
                animation-delay: 1.4s;
                animation-duration: 2s;
            }
            
            @keyframes brushSplash {
                0% {
                    transform: translate(-50%, -50%) scale(0);
                    opacity: 0.8;
                }
                100% {
                    transform: translate(-50%, -50%) scale(2.5);
                    opacity: 0;
                }
            }
            
            /* Hover efektleri */
            .first-name:hover, .second-name:hover {
                transform: scale(1.02);
                text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
                transition: all 0.3s ease;
            }
            
            /* Mobil cihazlarda font boyutunu ayarla */
            @media (max-width: 640px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 1px;
                    font-size: 3.5rem !important;
                }
            }
            
            @media (max-width: 480px) {
                .first-name, .second-name, .ampersand {
                    letter-spacing: 0.5px;
                    font-size: 3rem !important;
                }
            }
            
            /* Davetiye metni stili */
            .invitation-text {
                font-family: 'Nunito', sans-serif;
                color: #575956;
                font-weight: 400;
                line-height: 1.6;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
                opacity: 0.9;
                animation: fadeIn 1s ease-in-out;
            }
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 0.9; transform: translateY(0); }
            }

            /* DÜĞÜN BİLGİLERİ BÖLÜMÜ STİLLERİ */
            .wedding-info-title {
                font-family: 'Dancing Script', cursive;
                font-weight: 600;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
                animation: titleFadeIn 1s ease-out;
            }

            .wedding-info-line {
                width: 100px;
                height: 3px;
                background: linear-gradient(90deg, #efa38b, #8b9a7a);
                border-radius: 2px;
                animation: lineExpand 1.2s ease-out 0.3s forwards;
                transform: scaleX(0);
            }

            .wedding-info-card {
                display: flex;
                align-items: flex-start;
                gap: 20px;
                padding: 24px;
                background: rgba(255, 255, 255, 0.7);
                backdrop-filter: blur(20px);
                border-radius: 20px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                transition: all 0.3s ease;
                animation: cardSlideIn 0.8s ease-out forwards;
                opacity: 0;
                transform: translateY(30px);
            }

            .wedding-info-card:nth-child(1) { animation-delay: 0.2s; }
            .wedding-info-card:nth-child(2) { animation-delay: 0.4s; }
            .wedding-info-card:nth-child(3) { animation-delay: 0.6s; }

            .wedding-info-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 16px 48px rgba(0, 0, 0, 0.12),
                    inset 0 1px 0 rgba(255, 255, 255, 0.8);
                border-color: rgba(239, 163, 139, 0.4);
            }

            .wedding-info-icon {
                flex-shrink: 0;
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 50%;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
            }

            .wedding-info-card:hover .wedding-info-icon {
                transform: scale(1.1);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
            }

            .wedding-info-content {
                flex: 1;
            }

            .wedding-info-card-title {
                font-family: 'Dancing Script', cursive;
                font-size: 1.75rem;
                font-weight: 600;
                margin-bottom: 8px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .wedding-info-card-text {
                font-family: 'Nunito', sans-serif;
                line-height: 1.6;
            }

            /* YOL TARİFİ BUTONU */
            .wedding-directions-btn {
                padding: 18px 32px;
                background: linear-gradient(135deg, #efa38b, #d4a98a);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 8px 24px rgba(239, 163, 139, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
            }

            .wedding-directions-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                transition: left 0.6s ease;
            }

            .wedding-directions-btn:hover::before {
                left: 100%;
            }

            .wedding-directions-btn:hover {
                transform: translateY(-3px);
                box-shadow: 
                    0 12px 36px rgba(239, 163, 139, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                background: linear-gradient(135deg, #f0b49c, #d9b59a);
            }

            .wedding-directions-btn:active {
                transform: translateY(-1px);
            }

            /* HARİTA KONTEYNER */
            .wedding-map-container {
                background: rgba(255, 255, 255, 0.8);
                backdrop-filter: blur(20px);
                border-radius: 25px;
                padding: 24px;
                border: 1px solid rgba(139, 154, 122, 0.2);
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
                animation: mapSlideIn 1s ease-out 0.8s forwards;
                opacity: 0;
                transform: translateX(50px);
            }

            .wedding-map-header {
                margin-bottom: 20px;
                text-align: center;
            }

            .wedding-map-frame {
                width: 100%;
                height: 350px;
                border-radius: 15px;
                overflow: hidden;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                margin-bottom: 16px;
            }

            .wedding-map-footer {
                padding: 16px;
                background: rgba(255, 255, 255, 0.6);
                border-radius: 12px;
                border: 1px solid rgba(239, 163, 139, 0.15);
            }

            .wedding-map-btn {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
                border: 1px solid currentColor;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease;
            }

            .wedding-map-btn:hover {
                background: currentColor;
                color: white !important;
                transform: scale(1.1);
            }

            /* İLETİŞİM LİNKLERİ */
            .wedding-contact-link {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 20px;
                background: rgba(255, 255, 255, 0.6);
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 25px;
                color: #575956;
                text-decoration: none;
                font-family: 'Nunito', sans-serif;
                font-weight: 500;
                transition: all 0.3s ease;
            }

            .wedding-contact-link:hover {
                background: rgba(139, 154, 122, 0.1);
                border-color: rgba(139, 154, 122, 0.5);
                transform: translateY(-2px);
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            }

            /* Mektup bölümüne kaydırma butonu */
            .scroll-to-wishes-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                padding: 14px 28px;
                background: linear-gradient(135deg, #8b9a7a, #6b7569);
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 
                    0 6px 20px rgba(107, 117, 105, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                overflow: hidden;
                margin: 0 auto;
                animation: pulseAnimation 2s infinite;
            }

            .scroll-to-wishes-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                transition: left 0.6s ease;
            }

            .scroll-to-wishes-btn:hover::before {
                left: 100%;
            }

            .scroll-to-wishes-btn:hover {
                transform: translateY(-3px);
                background: linear-gradient(135deg, #9baa8a, #7b8579);
                box-shadow: 
                    0 10px 30px rgba(107, 117, 105, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.3);
                animation: none;
            }

            .scroll-to-wishes-btn:active {
                transform: translateY(-1px);
            }

            .scroll-to-wishes-btn svg {
                transition: transform 0.3s ease;
            }

            .scroll-to-wishes-btn:hover svg {
                transform: translateY(3px);
            }

            @keyframes pulseAnimation {
                0% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
                50% {
                    transform: scale(1.05);
                    box-shadow: 0 8px 25px rgba(107, 117, 105, 0.4);
                }
                100% {
                    transform: scale(1);
                    box-shadow: 0 6px 20px rgba(107, 117, 105, 0.3);
                }
            }

            /* ANİMASYONLAR */
            @keyframes titleFadeIn {
                from {
                    opacity: 0;
                    transform: translateY(-20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes lineExpand {
                to {
                    transform: scaleX(1);
                }
            }

            @keyframes cardSlideIn {
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes mapSlideIn {
                to {
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            /* RESPONSİVE TASARIM */
            @media (max-width: 1024px) {
                .wedding-map-frame {
                    height: 300px;
                }
            }

            @media (max-width: 768px) {
                .wedding-info-card {
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 16px;
                    padding: 20px;
                }

                .wedding-info-icon {
                    width: 56px;
                    height: 56px;
                }

                .wedding-map-frame {
                    height: 250px;
                }

                .wedding-map-container {
                    padding: 20px;
                }
            }

            @media (max-width: 640px) {
                .wedding-info-title {
                    font-size: 2.5rem !important;
                }

                .wedding-info-card {
                    padding: 16px;
                }

                .wedding-info-card-title {
                    font-size: 1.5rem;
                }

                .wedding-directions-btn {
                    padding: 16px 24px;
                }

                .wedding-contact-link {
                    padding: 10px 16px;
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 480px) {
                .wedding-info-title {
                    font-size: 2rem !important;
                }

                .wedding-map-frame {
                    height: 200px;
                }

                .wedding-map-container {
                    padding: 16px;
                }
            }

            /* LÜKS MEKTUP TASARIMI STİLLERİ */
            .luxury-letter-container {
                position: relative;
                max-width: 800px;
                margin: 0 auto;
                transform-style: preserve-3d;
                transition: all 0.6s ease;
                padding: 10px;
            }

            .luxury-letter-container:hover {
                transform: translateY(-5px);
            }

            .luxury-letter-decorations {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                pointer-events: none;
                z-index: 20;
            }

            .luxury-letter-corner {
                position: absolute;
                width: 30px;
                height: 30px;
                z-index: 30;
            }

            .luxury-letter-corner.top-left {
                top: 0;
                left: 0;
                border-top: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-top-left-radius: 8px;
            }

            .luxury-letter-corner.top-right {
                top: 0;
                right: 0;
                border-top: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-top-right-radius: 8px;
            }

            .luxury-letter-corner.bottom-left {
                bottom: 0;
                left: 0;
                border-bottom: 2px solid #d4a98a;
                border-left: 2px solid #d4a98a;
                border-bottom-left-radius: 8px;
            }

            .luxury-letter-corner.bottom-right {
                bottom: 0;
                right: 0;
                border-bottom: 2px solid #d4a98a;
                border-right: 2px solid #d4a98a;
                border-bottom-right-radius: 8px;
            }

            .luxury-letter-edge {
                position: absolute;
                z-index: 25;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
                opacity: 0.5;
            }

            .luxury-letter-edge.top {
                top: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.bottom {
                bottom: 0;
                left: 30px;
                right: 30px;
                height: 2px;
            }

            .luxury-letter-edge.left {
                left: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-edge.right {
                right: 0;
                top: 30px;
                bottom: 30px;
                width: 2px;
                background: linear-gradient(to bottom, transparent, #d4a98a, transparent);
            }

            .luxury-letter-content {
                background: #fff;
                padding: 40px 30px;
                border-radius: 8px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 3px 10px rgba(0, 0, 0, 0.02),
                    inset 0 0 0 1px rgba(239, 163, 139, 0.1);
                position: relative;
                z-index: 10;
                overflow: hidden;
            }

            .luxury-letter-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-ornament {
                flex-shrink: 0;
                opacity: 0.7;
                transition: all 0.5s ease;
            }

            .luxury-letter-container:hover .luxury-letter-ornament {
                opacity: 1;
                transform: scale(1.1);
            }

            .luxury-letter-title {
                flex: 1;
                text-align: center;
                position: relative;
                padding: 0 20px;
            }

            .luxury-letter-title h3 {
                font-family: 'Dancing Script', cursive;
                font-size: 2.8rem;
                font-weight: 600;
                color: #8b9a7a;
                margin: 0 0 10px;
                text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
            }

            .luxury-letter-title-underline {
                height: 2px;
                width: 70%;
                margin: 0 auto;
                background: linear-gradient(to right, transparent, #efa38b, transparent);
            }

            .luxury-letter-body {
                margin-bottom: 30px;
                position: relative;
            }

            .luxury-letter-textarea {
                width: 100%;
                min-height: 150px;
                border: 1px solid rgba(239, 163, 139, 0.2);
                border-radius: 6px;
                padding: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                color: #575956;
                background: rgba(255, 255, 255, 0.8);
                resize: none;
                transition: all 0.3s ease;
                line-height: 1.7;
                box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);
            }

            .luxury-letter-textarea:focus {
                outline: none;
                border-color: rgba(239, 163, 139, 0.4);
                box-shadow: 0 0 0 2px rgba(239, 163, 139, 0.1);
            }

            .luxury-letter-textarea::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-style: italic;
            }

            .luxury-letter-footer {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-top: 20px;
            }

            .luxury-letter-signature {
                width: 200px;
                position: relative;
            }

            .luxury-letter-signature-input {
                width: 100%;
                border: none;
                background: transparent;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #575956;
                padding: 5px 0;
                text-align: center;
            }

            .luxury-letter-signature-input:focus {
                outline: none;
            }

            .luxury-letter-signature-input::placeholder {
                color: rgba(107, 117, 105, 0.5);
                font-size: 1.1rem;
            }

            .luxury-letter-signature-line {
                width: 100%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(87, 89, 86, 0.2), transparent);
                margin-top: 5px;
            }

            .luxury-letter-download-btn {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 12px 24px;
                background: #efa38b;
                color: white;
                border: none;
                border-radius: 50px;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 1rem;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(239, 163, 139, 0.2);
            }

            .luxury-letter-download-btn::before {
                content: none;
            }

            .luxury-letter-download-btn:hover {
                transform: translateY(-2px);
                background: #f0b49c;
                box-shadow: 0 6px 16px rgba(239, 163, 139, 0.3);
            }

            .luxury-letter-download-btn:active {
                transform: translateY(0);
            }

            .luxury-letter-download-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: transform 0.3s ease;
            }

            .luxury-letter-download-btn:hover .luxury-letter-download-icon {
                transform: translateY(2px);
            }

            /* Altın Süslemeli Ayraç */
            .luxury-divider {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 60px 0;
                position: relative;
            }

            .luxury-divider-line {
                height: 1px;
                flex: 1;
                background: linear-gradient(to right, transparent, #d4a98a, transparent);
            }

            .luxury-divider-line.left {
                background: linear-gradient(to right, transparent, #d4a98a);
            }

            .luxury-divider-line.right {
                background: linear-gradient(to right, #d4a98a, transparent);
            }

            .luxury-divider-ornament {
                margin: 0 20px;
                color: #d4a98a;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: rotate(0deg);
                transition: transform 1s ease;
            }

            .luxury-divider:hover .luxury-divider-ornament {
                transform: rotate(360deg);
            }

            /* Dilek Kartları */
            .luxury-wish-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 10px 25px rgba(0, 0, 0, 0.05),
                    0 5px 10px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
            }

            .luxury-wish-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 5px;
                background: linear-gradient(to right, #efa38b, #d4a98a);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .luxury-wish-card:hover {
                transform: translateY(-10px);
                box-shadow: 
                    0 20px 40px rgba(0, 0, 0, 0.1),
                    0 10px 15px rgba(0, 0, 0, 0.03);
            }

            .luxury-wish-card-content {
                background: #fff;
                border-radius: 10px;
                padding: 25px;
                border: 1px solid rgba(139, 154, 122, 0.1);
            }

            .luxury-wish-text {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #575956;
                margin-bottom: 20px;
                font-style: italic;
            }

            .luxury-wish-signature {
                text-align: right;
                font-family: 'Dancing Script', cursive;
                font-size: 1.4rem;
                color: #8b9a7a;
                position: relative;
            }

            .luxury-wish-signature::before {
                content: '';
                position: absolute;
                bottom: -5px;
                right: 0;
                width: 50%;
                height: 1px;
                background: linear-gradient(to right, transparent, rgba(139, 154, 122, 0.3));
            }

            /* Mektup bölümü responsive tasarım */
            @media (max-width: 768px) {
                .luxury-letter-content {
                    padding: 40px 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2.5rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 60px;
                    height: 60px;
                }
                
                .luxury-letter-textarea {
                    padding: 20px;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 640px) {
                .luxury-letter-content {
                    padding: 30px 20px;
                }
                
                .luxury-letter-header {
                    margin-bottom: 30px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 2rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 50px;
                    height: 50px;
                }
                
                .luxury-letter-textarea {
                    padding: 15px;
                    font-size: 1rem;
                }
                
                .luxury-letter-footer {
                    flex-direction: column;
                    gap: 25px;
                    align-items: center;
                }
                
                .luxury-letter-signature {
                    width: 80%;
                    margin-bottom: 10px;
                }
                
                .luxury-letter-download-btn {
                    width: 100%;
                    justify-content: center;
                }
                
                .luxury-letter-download-btn span {
                    font-size: 0.85rem;
                }
                
                .luxury-wish-card-content {
                    padding: 20px;
                }
            }

            @media (max-width: 480px) {
                .luxury-letter-content {
                    padding: 25px 15px;
                }
                
                .luxury-letter-title h3 {
                    font-size: 1.75rem;
                }
                
                .luxury-letter-ornament svg {
                    width: 40px;
                    height: 40px;
                }
                
                .luxury-letter-signature-input {
                    font-size: 1.3rem;
                }
                
                .luxury-letter-download-btn {
                    padding: 12px 20px;
                }
                
                .luxury-divider-ornament {
                    margin: 0 10px;
                }
                
                .luxury-divider-ornament svg {
                    width: 30px;
                    height: 30px;
                }
            }

            /* HAZIR DİLEK ŞABLONLARI STİLLERİ */
            .wish-template-card {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                padding: 5px;
                box-shadow: 
                    0 8px 20px rgba(0, 0, 0, 0.05),
                    0 3px 8px rgba(0, 0, 0, 0.02);
                transition: all 0.3s ease;
                transform: translateY(0);
                position: relative;
                overflow: hidden;
                cursor: pointer;
                margin-bottom: 20px;
            }

            .wish-template-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(to right, #8b9a7a, #efa38b);
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
            }

            .wish-template-card:hover {
                transform: translateY(-5px);
                box-shadow: 
                    0 15px 30px rgba(0, 0, 0, 0.1),
                    0 8px 12px rgba(0, 0, 0, 0.03);
            }

            .wish-template-content {
                background: #fff;
                border-radius: 10px;
                padding: 20px;
                border: 1px solid rgba(139, 154, 122, 0.1);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .wish-template-preview {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                line-height: 1.6;
                color: #575956;
                margin-bottom: 15px;
                font-style: italic;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .wish-template-button {
                text-align: center;
                margin-top: auto;
            }

            .wish-template-button span {
                display: inline-block;
                padding: 8px 16px;
                background: rgba(139, 154, 122, 0.1);
                color: #8b9a7a;
                border: 1px solid rgba(139, 154, 122, 0.3);
                border-radius: 20px;
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                font-weight: 600;
                transition: all 0.3s ease;
            }

            .wish-template-card:hover .wish-template-button span {
                background: #8b9a7a;
                color: white;
                border-color: #8b9a7a;
            }

            @media (max-width: 768px) {
                .wish-template-preview {
                    -webkit-line-clamp: 4;
                    font-size: 0.85rem;
                }
                
                .wish-template-button span {
                    padding: 7px 14px;
                    font-size: 0.8rem;
                }
            }

            @media (max-width: 640px) {
                .wish-template-preview {
                    -webkit-line-clamp: 3;
                }
            }

            /* YENİ FOOTER STİLLERİ - GÖRSELDEKİ GİBİ */
            .wedding-footer-new {
                background-color: rgba(139, 154, 122, 0.95); /* Görseldeki yeşil ton - tek renk */
                color: #fff;
                padding: 60px 0 30px;
                position: relative;
                z-index: 50;
                text-align: center;
                border-top: 1px solid rgba(255, 255, 255, 0.2);
            }

            .wedding-footer-center {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 20px;
            }

            .wedding-footer-heart-icon {
                width: 60px;
                height: 60px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto 20px;
                color: white;
            }

            .wedding-footer-couple {
                font-family: 'Dancing Script', cursive;
                font-size: 3.5rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 25px;
                text-align: center;
            }

            .wedding-footer-message {
                max-width: 800px;
                margin: 0 auto 50px;
                font-family: 'Nunito', sans-serif;
                font-size: 1.1rem;
                line-height: 1.7;
                color: #fff;
                text-align: center;
                padding: 0 20px;
            }

            .wedding-footer-columns {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 80px;
                margin-bottom: 50px;
            }

            .wedding-footer-column {
                flex: 1;
                min-width: 250px;
                max-width: 450px;
                text-align: left;
            }

            .wedding-footer-subtitle {
                font-family: 'Dancing Script', cursive;
                font-size: 2rem;
                font-weight: 500;
                color: #fff;
                margin: 0 0 20px;
                text-align: left;
            }

            .wedding-footer-contact-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
            }

            .wedding-footer-icon-circle {
                width: 36px;
                height: 36px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 15px;
                flex-shrink: 0;
            }

            .wedding-footer-witness {
                font-family: 'Nunito', sans-serif;
                font-size: 1rem;
                line-height: 1.7;
                color: #fff;
                text-align: left;
            }

            .wedding-footer-divider-new {
                height: 1px;
                background: rgba(255, 255, 255, 0.2);
                margin: 30px auto;
                width: 100%;
                max-width: 900px;
            }

            .wedding-footer-bottom-new {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
            }

            .wedding-footer-copyright-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.9rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-quote {
                font-family: 'Dancing Script', cursive;
                font-size: 1.1rem;
                font-style: italic;
                color: rgba(255, 255, 255, 0.8);
                margin: 10px 0;
            }

            .wedding-footer-credit-new {
                font-family: 'Nunito', sans-serif;
                font-size: 0.85rem;
                color: rgba(255, 255, 255, 0.7);
                margin: 0;
            }

            .wedding-footer-credit-new span {
                color: #efa38b;
                font-weight: 600;
            }

            @media (max-width: 768px) {
                .wedding-footer-new {
                    padding: 40px 0 20px;
                }
                
                .wedding-footer-couple {
                    font-size: 2.8rem;
                }
                
                .wedding-footer-message {
                    font-size: 1rem;
                    margin-bottom: 40px;
                }
                
                .wedding-footer-columns {
                    flex-direction: column;
                    gap: 40px;
                    align-items: center;
                }
                
                .wedding-footer-column {
                    width: 100%;
                    max-width: 100%;
                    text-align: center;
                }
                
                .wedding-footer-subtitle {
                    text-align: center;
                    font-size: 1.8rem;
                }
                
                .wedding-footer-contact-item {
                    justify-content: center;
                }
                
                .wedding-footer-witness {
                    text-align: center;
                }
            }

            @media (max-width: 480px) {
                .wedding-footer-couple {
                    font-size: 2.2rem;
                }
                
                .wedding-footer-message {
                    font-size: 0.9rem;
                }
                
                .wedding-footer-subtitle {
                    font-size: 1.6rem;
                }
                
                .wedding-footer-heart-icon {
                    width: 50px;
                    height: 50px;
                }
            }

            /* iPhone Özel Arka Plan Düzeltmeleri */
            @supports (-webkit-touch-callout: none) {
                .wedding-background {
                    background-attachment: scroll !important;
                    background-size: cover !important;
                    background-position: center center !important;
                    height: 100vh !important;
                    width: 100vw !important;
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    transform: none !important;
                }
            }

            /* iPhone ve iOS Safari için özel düzeltmeler */
            @media screen and (max-width: 768px) and (-webkit-min-device-pixel-ratio: 2) {
                .wedding-background {
                    background-attachment: scroll !important;
                    background-size: cover !important;
                    background-position: center center !important;
                    min-height: 100vh !important;
                    min-height: -webkit-fill-available !important;
                    height: 100vh !important;
                    height: -webkit-fill-available !important;
                    width: 100vw !important;
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    transform: none !important;
                    overflow: hidden !important;
                }
            }

            /* iPhone X ve sonrası için safe area desteği */
            @media screen and (max-width: 768px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 3) {
                .wedding-background {
                    background-attachment: scroll !important;
                    background-size: cover !important;
                    background-position: center center !important;
                    min-height: 100vh !important;
                    min-height: -webkit-fill-available !important;
                    height: 100vh !important;
                    height: -webkit-fill-available !important;
                    width: 100vw !important;
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    transform: none !important;
                    overflow: hidden !important;
                    padding-top: env(safe-area-inset-top) !important;
                    padding-bottom: env(safe-area-inset-bottom) !important;
                }
            }

            /* ANİMASYONLAR */
        `}</style>
        </div>
    );
};

export default Wedding;

